<template>
  <v-container fluid>
    <v-progress-linear v-if="$vars.loading" indeterminate class="primary--text loader"></v-progress-linear>
    <v-toolbar dense flat>
      <v-row no-gutters>
        <v-col cols="2" class="text-left">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" icon @click="showSchankverlustData = !showSchankverlustData">%</v-btn>
            </template>
            <span>Schankverlusttabelle anzeigen</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" icon @click="showNurBbrBbr = !showNurBbrBbr">
                <v-icon v-if="showNurBbrBbr">group</v-icon>
                <v-icon v-else>groups</v-icon>
              </v-btn>
            </template>
            <span>Filter: Nur BbrBbr</span>
          </v-tooltip>
          <v-tooltip bottom v-if="currentBbr === 'PBChUyAy7HWowQR4HlP3'">
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" icon @click="showDebug = !showDebug"><v-icon>bug_report</v-icon></v-btn>
            </template>
            <span>Debug Dialog anzeigen</span>
          </v-tooltip>
        </v-col>
        <v-col cols="8">
          <v-tabs centered v-model="jahrSelect" center-active>
            <v-tab v-for="(jahr, index) in jahre" :key="index">
              {{ jahr }}
            </v-tab>
          </v-tabs>
        </v-col>
        <v-col cols="2" class="text-right">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" icon @click="addMonat(false)"><v-icon>refresh</v-icon></v-btn>
            </template>
            <span>Monat berechnen</span>
          </v-tooltip>
        </v-col>
      </v-row>
    </v-toolbar>
    <v-divider></v-divider>
    <v-toolbar dense flat>
      <v-tabs grow v-model="monatSelect">
        <v-tab
          :disabled="daten.find((datum) => datum === jahre[jahrSelect] + '-' + monat + '-01') === undefined"
          v-for="(monat, index) in monate"
          :key="index"
        >
          {{ $filters.date(jahre[jahrSelect] + "-" + monat, "MMM") }}
        </v-tab>
        <v-tab> Jahr </v-tab>
      </v-tabs>
    </v-toolbar>
    <v-divider></v-divider>

    <v-row v-if="statistik !== null" no-gutters class="mt-4 ma-2">
      <v-col order="first" cols="12" xs="12" class="px-1" v-if="showSchankverlustData">
        <v-card outlined class="mb-4">
          <v-card-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="showSchankverlustData = false"><v-icon>close</v-icon></v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-simple-table fixed-header>
            <thead>
              <tr>
                <th>Zeitraum</th>
                <th class="text-center">Oettingerkisten</th>
                <th class="text-center">Schankverlust</th>
                <th class="text-center">Striche Theorie</th>
                <th class="text-center">Striche Praxis</th>
                <th class="text-center">Couleurstriche</th>
                <th class="text-center amber lighten-2">Kosten Oettinger<br />und Couleurbier</th>
                <th class="text-center amber lighten-2">Fehlbetrag <br />Schankverlust</th>
                <th class="text-center amber lighten-2">Fehlbetrag <br />Schankverlust (-10%)</th>
                <th class="text-center amber">Summe</th>
              </tr>
            </thead>
            <tbody>
              <tr class="text-center">
                <td class="text-left">{{ $filters.date(jahre[jahrSelect] + "-" + monate[monatSelect], "MM.YYYY") }}</td>
                <td>{{ statistik.oettingerKisten }}</td>
                <td>{{ statistik.schankverlust }}%</td>
                <td>{{ statistik.gesamtStricheTheorie }}</td>
                <td>{{ statistik.gesamtStrichePraxis }}</td>
                <td>{{ statistik.couleurstricheAnzahl }}</td>
                <td class="amber lighten-2">
                  {{ (parseFloat(statistik.oettingerKistenPreis) + parseFloat(statistik.couleurstrichePreis)) | money }}
                </td>
                <td class="amber lighten-2">
                  {{
                    ((statistik.gesamtStricheTheorie - statistik.gesamtStrichePraxis) *
                      statistik.durchschnittsStrichPreis)
                      | money
                  }}
                </td>
                <td class="amber lighten-2">
                  {{
                    ((statistik.gesamtStricheTheorie -
                      statistik.gesamtStricheTheorie * 0.1 -
                      statistik.gesamtStrichePraxis) *
                      statistik.durchschnittsStrichPreis)
                      | money
                  }}
                </td>
                <td class="amber">
                  {{
                    (parseFloat(statistik.oettingerKistenPreis) +
                      parseFloat(statistik.couleurstrichePreis) +
                      (statistik.gesamtStricheTheorie - statistik.gesamtStrichePraxis) *
                        statistik.durchschnittsStrichPreis)
                      | money
                  }}
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card>
      </v-col>

      <v-col order-xs="" cols="12" md="2" class="px-1">
        <v-card class="mb-2" outlined>
          <v-card-title class="pa-0 overline"><v-spacer></v-spacer>Bester Tag<v-spacer></v-spacer></v-card-title>
          <v-card-title class="pa-0"
            ><v-spacer></v-spacer>{{ $filters.date(statistik.stricheProTagBest[0], "DD.MM.YYYY") }}<v-spacer></v-spacer
          ></v-card-title>
          <v-card-title class="pa-0 caption"
            ><v-spacer></v-spacer>{{ statistik.stricheProTagBest[1] }} Striche<v-spacer></v-spacer
          ></v-card-title>
        </v-card>
        <v-card class="mb-2" outlined>
          <v-card-title class="pa-0 overline"
            ><v-spacer></v-spacer>BbrBbr an der Theke<v-spacer></v-spacer
          ></v-card-title>
          <v-card-title class="pa-0"
            ><v-spacer></v-spacer>{{ statistik.stricheProBbrCount }}<v-spacer></v-spacer
          ></v-card-title>
        </v-card>
        <v-card class="mb-2" outlined>
          <v-card-title class="pa-0 overline"><v-spacer></v-spacer>Couleurstriche<v-spacer></v-spacer></v-card-title>
          <v-card-title class="pa-0"
            ><v-spacer></v-spacer>{{ statistik.couleurstricheAnzahl }}<v-spacer></v-spacer
          ></v-card-title>
        </v-card>
        <v-card class="mb-2" outlined>
          <v-card-title class="pa-0 overline"
            ><v-spacer></v-spacer>Striche (ohne EKP)<v-spacer></v-spacer
          ></v-card-title>
          <v-card-title class="pa-0"
            ><v-spacer></v-spacer>{{ statistik.stricheBbrAnzahl }}<v-spacer></v-spacer
          ></v-card-title>
        </v-card>
        <v-card class="mb-2" outlined>
          <v-btn absolute icon right fab x-small @click="showVermogen()"><v-icon>edit</v-icon></v-btn>
          <v-card-title class="pa-0 overline justify-center">Vermögen</v-card-title>
          <v-card-title class="pa-0 justify-center">
            {{ $sumArray(statistik.gesamtvermogen) | money }}
          </v-card-title>
          <span v-if="jahrStatistik.vermogen">
            <v-card-title
              class="pa-0 justify-center caption"
              v-if="jahrStatistik.vermogen[monatSelect - 1] && jahrStatistik.vermogen[monatSelect]"
            >
              {{
                ((jahrStatistik.vermogen[monatSelect] / jahrStatistik.vermogen[monatSelect - 1]) * 100 - 100).toFixed(0)
              }}
              %
            </v-card-title>
          </span>
        </v-card>
        <v-card class="mb-2" outlined>
          <v-card-title class="pa-0 overline justify-center">Steuerlast an AHV</v-card-title>
          <v-card-title class="pa-0 justify-center">
            {{ statistik.steuerlast | money }}
          </v-card-title>
          <span v-if="jahrStatistik.vermogen">
            <v-card-title
              class="pa-0 justify-center caption"
              v-if="jahrStatistik.vermogen[monatSelect - 1] && jahrStatistik.vermogen[monatSelect]"
            >
              {{
                ((jahrStatistik.vermogen[monatSelect] / jahrStatistik.vermogen[monatSelect - 1]) * 100 - 100).toFixed(0)
              }}
              %
            </v-card-title>
          </span>
        </v-card>
      </v-col>

      <v-col order-xs="" cols="12" md="10" class="px-1">
        <v-row no-gutters>
          <v-col cols="12" md="9" class="px-1">
            <v-row no-gutters>
              <v-col cols="4" class="pr-1">
                <v-card
                  class="mb-2"
                  outlined
                  @click="(showArray = 'schankverlust') && show(jahresStatistik.schankverlust)"
                >
                  <v-card-title class="overline pa-0 justify-space-between">
                    <v-icon color="transparent">touch_app</v-icon>
                    Schankverlust
                    <v-icon>touch_app</v-icon>
                  </v-card-title>
                  <v-card-title class="pa-0 justify-center">{{ statistik.schankverlust }}%</v-card-title>
                </v-card>
              </v-col>
              <v-col cols="4" class="px-1">
                <v-card
                  class="mb-2"
                  outlined
                  @click="(showArray = 'gesamtStriche') && show(jahresStatistik.gesamtStriche)"
                >
                  <v-card-title class="overline pa-0 justify-space-between">
                    <v-icon color="transparent">touch_app</v-icon>
                    Striche
                    <v-icon>touch_app</v-icon>
                  </v-card-title>
                  <v-card-title class="pa-0 justify-center"
                    >{{ statistik.gesamtStricheTheorie }} | {{ statistik.gesamtStrichePraxis }}</v-card-title
                  >
                </v-card>
              </v-col>
              <v-col cols="4" class="pl-1">
                <v-card class="mb-2" outlined @click="(showArray = 'volumen') && show(jahresStatistik.volumen)">
                  <v-card-title class="overline pa-0 justify-space-between">
                    <v-icon color="transparent">touch_app</v-icon>
                    Volumen
                    <v-icon>touch_app</v-icon>
                  </v-card-title>
                  <v-card-title class="pa-0 justify-center">{{ statistik.volumen }}L</v-card-title>
                </v-card>
              </v-col>
            </v-row>
            <v-card v-if="showArray === 'schankverlust'" outlined class="mb-2" height="calc(100% - 82px)">
              <apexchart height="200" type="bar" :options="options4" :series="series"></apexchart>
            </v-card>
            <v-card v-if="showArray === 'gesamtStriche'" outlined class="mb-2" height="calc(100% - 82px)">
              <apexchart height="200" type="area" :options="options" :series="series"></apexchart>
            </v-card>
            <v-card v-if="showArray === 'volumen'" outlined class="mb-2" height="calc(100% - 82px)">
              <apexchart height="200" type="bar" :options="options" :series="series"></apexchart>
            </v-card>
            <v-card v-if="showArray === 'vermogen'" outlined class="mb-2" height="calc(100% - 82px)">
              <v-row v-if="statistik.gesamtvermogen" no-gutters class="pa-1">
                <v-col cols="4">
                  <v-row no-gutters>
                    <v-col cols="12" class="pa-1"
                      ><v-text-field
                        outlined
                        dense
                        hide-details
                        type="number"
                        label="Kontostand"
                        v-model="statistik.gesamtvermogen.kontostand"
                      ></v-text-field
                    ></v-col>
                    <v-col cols="12" class="pa-1"
                      ><v-text-field
                        outlined
                        dense
                        hide-details
                        type="number"
                        label="Getränkestand"
                        v-model="statistik.gesamtvermogen.getrankestand"
                      ></v-text-field
                    ></v-col>
                    <v-col cols="12" class="pa-1"
                      ><v-text-field
                        outlined
                        dense
                        hide-details
                        type="number"
                        label="Fuxenkasse"
                        v-model="statistik.gesamtvermogen.fuxenkasse"
                      ></v-text-field
                    ></v-col>
                    <v-col cols="12" class="pa-1"
                      ><v-text-field
                        outlined
                        dense
                        hide-details
                        type="number"
                        label="Sonstiges"
                        v-model="statistik.gesamtvermogen.sonstiges"
                      ></v-text-field
                    ></v-col>
                  </v-row>
                </v-col>
                <v-col cols="4">
                  <v-row no-gutters>
                    <v-col cols="12" class="pa-1"
                      ><v-text-field
                        outlined
                        dense
                        hide-details
                        number
                        label="Offene Rechnungen"
                        v-model="statistik.gesamtvermogen.rechnungen_offen"
                      ></v-text-field
                    ></v-col>
                    <v-col cols="12" class="pa-1"
                      ><v-text-field
                        outlined
                        dense
                        hide-details
                        number
                        label="Offene SEPA-Rechnungen"
                        v-model="statistik.gesamtvermogen.rechnungen_sepa"
                      ></v-text-field
                    ></v-col>
                    <v-col cols="12" class="pa-1"
                      ><v-text-field
                        outlined
                        dense
                        hide-details
                        number
                        label="Überfällige Rechnungen"
                        v-model="statistik.gesamtvermogen.rechnungen_ueberfaellig"
                      ></v-text-field
                    ></v-col>
                    <v-col cols="12" class="pa-1"
                      ><v-text-field
                        outlined
                        dense
                        hide-details
                        number
                        label="Gemahnte Rechnungen"
                        v-model="statistik.gesamtvermogen.rechnungen_gemahnt"
                      ></v-text-field
                    ></v-col>
                  </v-row>
                </v-col>
                <v-col cols="4" class="pa-2">
                  Trag hier alle Werte zum Ende des Monats ein.
                  <v-btn block @click="saveGesamtvermogen()" class="mt-8">Speichern</v-btn>
                </v-col>
              </v-row>
              <!-- <v-row v-if="gesamtvermogen.kontostand" no-gutters class="pa-1">
                <v-col cols="4">
                  <v-row no-gutters>
                    <v-col cols="12" class="pa-1"><v-text-field outlined dense hide-details type="number" label="Kontostand" v-model="gesamtvermogen.kontostand"></v-text-field></v-col>
                    <v-col cols="12" class="pa-1"><v-text-field outlined dense hide-details type="number" label="Getränkestand" v-model="gesamtvermogen.getrankestand"></v-text-field></v-col>
                    <v-col cols="12" class="pa-1"><v-text-field outlined dense hide-details type="number" label="Fuxenkasse" v-model="gesamtvermogen.fuxenkasse"></v-text-field></v-col>
                    <v-col cols="12" class="pa-1"><v-text-field outlined dense hide-details type="number" label="Sonstiges" v-model="gesamtvermogen.sonstiges"></v-text-field></v-col>
                  </v-row>
                </v-col>
                <v-col cols="4">
                  <v-row no-gutters>
                    <v-col cols="12" class="pa-1"><v-text-field outlined dense hide-details number label="Offene Rechnungen" v-model="gesamtvermogen.rechnungen_offen"></v-text-field></v-col>
                    <v-col cols="12" class="pa-1"><v-text-field outlined dense hide-details number label="Offene SEPA-Rechnungen" v-model="gesamtvermogen.rechnungen_sepa"></v-text-field></v-col>
                    <v-col cols="12" class="pa-1"><v-text-field outlined dense hide-details number label="Überfällige Rechnungen" v-model="gesamtvermogen.rechnungen_ueberfaellig"></v-text-field></v-col>
                    <v-col cols="12" class="pa-1"><v-text-field outlined dense hide-details number label="Gemahnte Rechnungen" v-model="gesamtvermogen.rechnungen_gemahnt"></v-text-field></v-col>
                  </v-row>
                </v-col>
                <v-col cols="4">
                  <v-card class="d-flex align-end fill-height pa-1" flat>
                    <v-btn block @click="saveGesamtvermogen()">Speichern</v-btn>
                  </v-card>
                </v-col>
              </v-row> -->
            </v-card>
          </v-col>
          <v-col cols="12" md="3" class="px-1 mb-2">
            <v-card outlined class="mb-2" height="100%">
              <v-tabs grow>
                <v-tab>BbrBbr</v-tab>
                <v-tab>Status</v-tab>
                <v-tab-item>
                  <v-simple-table dense fixed-header>
                    <tbody>
                      <tr
                        v-for="(item, index) in statistik.stricheProBbrSortiert"
                        :key="item.id"
                        v-on:dblclick="(bbr = item) && (showBbr = true)"
                      >
                        <td width="30px" v-if="index === 0">
                          <v-icon class="amber--text lighten-1">emoji_events</v-icon>
                        </td>
                        <td width="30px" v-if="index === 1">
                          <v-icon class="grey--text lighten-1">emoji_events</v-icon>
                        </td>
                        <td width="30px" v-if="index === 2">
                          <v-icon class="deep-orange--text darken-3">emoji_events</v-icon>
                        </td>
                        <td width="30px" v-if="index > 2"><v-icon>military_tech</v-icon></td>
                        <td>{{ $filters.user(item[0], bbrbbr) }}</td>
                        <td>{{ item[1] }}</td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                </v-tab-item>
                <v-tab-item>
                  <v-simple-table dense fixed-header>
                    <tbody>
                      <tr
                        v-for="(item, index) in statistik.stricheProStatusSortiert"
                        :key="item.id"
                        v-on:dblclick="(bbr = item) && (showBbr = true)"
                      >
                        <td width="30px" v-if="index === 0">
                          <v-icon class="amber--text lighten-1">emoji_events</v-icon>
                        </td>
                        <td width="30px" v-if="index === 1">
                          <v-icon class="grey--text lighten-1">emoji_events</v-icon>
                        </td>
                        <td width="30px" v-if="index === 2">
                          <v-icon class="deep-orange--text darken-3">emoji_events</v-icon>
                        </td>
                        <td width="30px" v-if="index > 2"><v-icon>military_tech</v-icon></td>
                        <td>{{ item[0] }}</td>
                        <td>{{ item[1] }}</td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                </v-tab-item>
              </v-tabs>
            </v-card>
          </v-col>
          <v-col cols="12" md="4" class="px-1">
            <v-card outlined class="mb-2">
              <v-progress-linear
                height="48"
                :value="(statistik.verbrauchBierSumme / statistik.volumen) * 100"
                color="primary"
              >
                <v-row no-gutters class="mx-2">
                  <v-col cols="6">Bier</v-col>
                  <v-col cols="6" class="text-right">{{ statistik.verbrauchBierSumme }} L</v-col>
                </v-row>
              </v-progress-linear>
              <v-divider></v-divider>
              <v-simple-table fixed-header height="223px" dense>
                <thead>
                  <tr>
                    <th class="text-left">Bezeichnung</th>
                    <th class="text-center">EKP</th>
                    <th class="text-center">Verbraucht</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in statistik.verbrauchBier" :key="item.bezeichnung" v-on:dblclick="goToId(item.id)">
                    <td class="text-left">{{ item.bezeichnung }}</td>
                    <td class="text-center">{{ item.ekp }}</td>
                    <td class="text-center">{{ item.verbraucht }}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-card>
          </v-col>
          <v-col cols="12" md="4" class="px-1">
            <v-card outlined class="mb-2">
              <v-progress-linear
                height="48"
                :value="(statistik.verbrauchSoftdrinksSumme / statistik.volumen) * 100"
                color="tertiary"
              >
                <v-row no-gutters class="mx-2">
                  <v-col cols="6">Softdrinks</v-col>
                  <v-col cols="6" class="text-right">{{ statistik.verbrauchSoftdrinksSumme }} L</v-col>
                </v-row>
              </v-progress-linear>
              <v-divider></v-divider>
              <v-simple-table fixed-header height="223px" dense>
                <thead>
                  <tr>
                    <th class="text-left">Bezeichnung</th>
                    <th class="text-center">EKP</th>
                    <th class="text-center">Verbraucht</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="item in statistik.verbrauchSoftdrinks"
                    :key="item.bezeichnung"
                    v-on:dblclick="goToId(item.id)"
                  >
                    <td class="text-left">{{ item.bezeichnung }}</td>
                    <td class="text-center">{{ item.ekp }}</td>
                    <td class="text-center">{{ item.verbraucht }}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-card>
          </v-col>
          <v-col cols="12" md="4" class="px-1">
            <v-card outlined class="mb-2">
              <v-progress-linear
                height="48"
                :value="(statistik.verbrauchWeinSchnapsSumme / statistik.volumen) * 100"
                color="amber"
              >
                <v-row no-gutters class="mx-2">
                  <v-col cols="8">Wein & Schnaps</v-col>
                  <v-col cols="4" class="text-right">{{ statistik.verbrauchWeinSchnapsSumme }} L</v-col>
                </v-row>
              </v-progress-linear>
              <v-divider></v-divider>
              <v-simple-table fixed-header height="223px" dense>
                <thead>
                  <tr>
                    <th class="text-left">Bezeichnung</th>
                    <th class="text-center">EKP</th>
                    <th class="text-center">Verbraucht</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="item in statistik.verbrauchWeinSchnaps"
                    :key="item.bezeichnung"
                    v-on:dblclick="goToId(item.id)"
                  >
                    <td class="text-left">{{ item.bezeichnung }}</td>
                    <td class="text-center">{{ item.ekp }}</td>
                    <td class="text-center">{{ item.verbraucht }}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12">
        <span class="caption ml-4">
          Zuletzt aktualisiert: {{ $filters.date(statistik.aktualisiert.seconds * 1000, "DD.MM.YYYY hh:mm") }}</span
        >
      </v-col>
    </v-row>
    <!------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
      ------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
      ------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------

      
      Jahres Statistik xs-lg Kleinere Screens

      ------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
      ------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
      ----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------->
    <v-row v-else class="ma-2" no-gutters>
      <v-col cols="12" v-if="monatSelect === 12" class="hidden-xl-only">
        <v-row no-gutters>
          <v-col order="5" order-md="1" cols="6" md="3" class="px-1">
            <v-card class="mb-1" outlined>
              <v-card-title class="pa-0 overline"
                ><v-spacer></v-spacer>BbrBbr an der Theke<v-spacer></v-spacer
              ></v-card-title>
              <v-card-title class="pa-0"
                ><v-spacer></v-spacer>{{ jahrStatistik.bestenliste.length }}<v-spacer></v-spacer
              ></v-card-title>
            </v-card>
            <v-card class="mb-1" outlined>
              <v-card-title class="pa-0 overline"
                ><v-spacer></v-spacer>Tage an der Theke<v-spacer></v-spacer
              ></v-card-title>
              <v-card-title class="pa-0"
                ><v-spacer></v-spacer>{{ jahrStatistik.tageAnDerTheke }}<v-spacer></v-spacer
              ></v-card-title>
            </v-card>
            <v-card class="mb-1" outlined>
              <v-card-title class="pa-0 overline"><v-spacer></v-spacer>Striche<v-spacer></v-spacer></v-card-title>
              <v-card-title class="pa-0"
                ><v-spacer></v-spacer>{{ jahrStatistik.gesamtStriche.summe }}<v-spacer></v-spacer
              ></v-card-title>
            </v-card>
            <v-card class="mb-1" outlined>
              <v-card-title class="pa-0 overline"><v-spacer></v-spacer>Bester Tag<v-spacer></v-spacer></v-card-title>
              <v-card-title class="pa-0"
                ><v-spacer></v-spacer>{{ $filters.date(jahrStatistik.besterTag.datum, "DD.MM.YYYY")
                }}<v-spacer></v-spacer
              ></v-card-title>
            </v-card>
            <v-card class="mb-1" outlined>
              <v-card-title class="pa-0 overline"><v-spacer></v-spacer>Bester Tag<v-spacer></v-spacer></v-card-title>
              <v-card-title class="pa-0"
                ><v-spacer></v-spacer>{{ jahrStatistik.besterTag.anzahl }} Striche<v-spacer></v-spacer
              ></v-card-title>
            </v-card>
          </v-col>
          <v-col order="4" order-md="2" cols="12" md="6" class="px-1 mb-1">
            <v-card outlined height="100%">
              <v-row no-gutters class="mx-1 px-1 mx-sm-12 px-sm-12">
                <v-col cols="4" class="mt-4 px-1">
                  <v-card outlined height="100%" class="grey lighten-2">
                    <v-card-title class="pa-0 pt-2 overline"
                      ><v-spacer></v-spacer><v-icon size="48" class="grey--text lighten-1">emoji_events</v-icon
                      ><v-spacer></v-spacer
                    ></v-card-title>
                    <v-card-title class="pa-0 pt-3 overline"
                      ><v-spacer></v-spacer>2. Platz<v-spacer></v-spacer
                    ></v-card-title>
                    <v-card-title class="pa-0 subtitle-2 text-truncate"
                      ><v-spacer></v-spacer
                      ><v-spacer>{{ $filters.user(jahrStatistik.bestenliste[1].bbr, bbrbbr) }}</v-spacer></v-card-title
                    >
                    <v-card-title class="pa-0 pb-2 caption"
                      ><v-spacer></v-spacer>{{ jahrStatistik.bestenliste[1].anzahl }} Striche<v-spacer></v-spacer
                    ></v-card-title>
                  </v-card>
                </v-col>
                <v-col cols="4" class="px-1 mt-1">
                  <v-card outlined height="100%" class="amber lighten-4">
                    <v-card-title class="pa-0 pt-2 overline"
                      ><v-spacer></v-spacer><v-icon size="48" class="amber--text lighten-1">emoji_events</v-icon
                      ><v-spacer></v-spacer
                    ></v-card-title>
                    <v-card-title class="pa-0 pt-6 overline"
                      ><v-spacer></v-spacer>1. Platz<v-spacer></v-spacer
                    ></v-card-title>
                    <v-card-title class="pa-0 subtitle-2 text-truncate"
                      ><v-spacer></v-spacer
                      ><v-spacer>{{ $filters.user(jahrStatistik.bestenliste[0].bbr, bbrbbr) }}</v-spacer></v-card-title
                    >
                    <v-card-title class="pa-0 pb-2 caption"
                      ><v-spacer></v-spacer>{{ jahrStatistik.bestenliste[0].anzahl }} Striche<v-spacer></v-spacer
                    ></v-card-title>
                  </v-card>
                </v-col>
                <v-col cols="4" class="px-1 mt-7">
                  <v-card outlined height="100%" class="deep-orange lighten-5">
                    <v-card-title class="pa-0 pt-2 overline"
                      ><v-spacer></v-spacer><v-icon size="48" class="deep-orange--text darken-3">emoji_events</v-icon
                      ><v-spacer></v-spacer
                    ></v-card-title>
                    <v-card-title class="pa-0 overline"
                      ><v-spacer></v-spacer>3. Platz<v-spacer></v-spacer
                    ></v-card-title>
                    <v-card-title class="pa-0 subtitle-2 text-truncate"
                      ><v-spacer></v-spacer
                      ><v-spacer>{{ $filters.user(jahrStatistik.bestenliste[2].bbr, bbrbbr) }}</v-spacer></v-card-title
                    >
                    <v-card-title class="pa-0 pb-2 caption"
                      ><v-spacer></v-spacer>{{ jahrStatistik.bestenliste[2].anzahl }} Striche<v-spacer></v-spacer
                    ></v-card-title>
                  </v-card>
                </v-col>
              </v-row>
              <v-simple-table fixed-header dense height="152px" class="mt-6">
                <tbody>
                  <tr v-for="(item, index) in jahrStatistik.bestenliste" :key="item.bbr" v-if="index > 2">
                    <td width="30px"><v-icon>military_tech</v-icon></td>
                    <td width="30px">{{ index + 1 }}.</td>
                    <td>{{ $filters.user(item.bbr, bbrbbr) }}</td>
                    <td width="30px">{{ item.anzahl }}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-card>
          </v-col>
          <v-col order="6" order-md="3" cols="6" md="3" class="px-1">
            <v-card class="mb-1" outlined>
              <v-card-title class="pa-0 overline"><v-spacer></v-spacer>Schankverlust<v-spacer></v-spacer></v-card-title>
              <v-card-title class="pa-0"
                ><v-spacer></v-spacer>{{ jahrStatistik.schankverlust.gesamt }} %<v-spacer></v-spacer
              ></v-card-title>
              <v-card-title class="pa-0 caption"
                ><v-spacer></v-spacer>{{ jahrStatistik.schankverlust.preis | money }}<v-spacer></v-spacer
              ></v-card-title>
            </v-card>
            <v-card class="mb-1" outlined>
              <v-card-title class="pa-0 overline"
                ><v-spacer></v-spacer>Couleurstriche<v-spacer></v-spacer
              ></v-card-title>
              <v-card-title class="pa-0"
                ><v-spacer></v-spacer>{{ jahrStatistik.couleurstriche }} Striche<v-spacer></v-spacer
              ></v-card-title>
              <v-card-title class="pa-0"
                ><v-spacer></v-spacer>{{ jahrStatistik.oettingerKisten.summe }} Ötti-Kisten<v-spacer></v-spacer
              ></v-card-title>
              <v-card-title class="pa-0 caption"
                ><v-spacer></v-spacer
                >{{ (jahrStatistik.oettingerKisten.preis + jahrStatistik.couleurstrichePreis) | money
                }}<v-spacer></v-spacer
              ></v-card-title>
            </v-card>
            <v-card class="mb-1" outlined>
              <v-card-title class="pa-0 overline"><v-spacer></v-spacer>Umsatz<v-spacer></v-spacer></v-card-title>
              <v-card-title class="pa-0"
                ><v-spacer></v-spacer>{{ jahrStatistik.umsatz.summe | money }}<v-spacer></v-spacer
              ></v-card-title>
            </v-card>
          </v-col>
          <v-col order="2" order-md="4" cols="12" md="3" class="px-1">
            <v-card class="mb-1 pa-2 pt-1" outlined height="100%">
              <v-virtual-scroll
                height="250"
                bench="2"
                item-height="36"
                :items="jahrStatistik.verbrauchBierSorte"
                class="mt-1"
              >
                <template v-slot:default="{ item, index }">
                  <v-progress-linear
                    rounded
                    height="32"
                    :value="jahrStatistik.verbrauchBier.donut.series[index]"
                    :color="
                      jahrStatistik.verbrauchBier.donut.series[index] > 50
                        ? 'primary'
                        : jahrStatistik.verbrauchBier.donut.series[index] > 25
                        ? 'primary lighten-1'
                        : jahrStatistik.verbrauchBier.donut.series[index] > 10
                        ? 'primary lighten-2'
                        : jahrStatistik.verbrauchBier.donut.series[index] > 5
                        ? 'primary lighten-3'
                        : 'primary lighten-4'
                    "
                  >
                    <v-row no-gutters class="mx-2">
                      <v-col cols="4">{{ item.Id }}</v-col>
                      <v-col cols="4" class="text-center"
                        ><strong>{{ jahrStatistik.verbrauchBier.donut.series[index] }}%</strong></v-col
                      >
                      <v-col cols="4" class="text-right">{{ item.liter }} l</v-col>
                    </v-row>
                  </v-progress-linear>
                </template>
              </v-virtual-scroll>
            </v-card>
          </v-col>
          <v-col order="1" order-md="5" cols="12" md="6" class="px-1">
            <v-card outlined>
              <v-row no-gutters>
                <v-col cols="4">
                  <v-row no-gutters>
                    <v-col cols="12" class="px-1">
                      <v-card class="mb-1 mt-1" flat>
                        <v-card-title class="pa-0 pt-5 overline"
                          ><v-spacer></v-spacer><v-badge dot inline left color="primary">Bier</v-badge
                          ><v-spacer></v-spacer
                        ></v-card-title>
                        <v-card-title class="pa-0"
                          ><v-spacer></v-spacer>{{ jahrStatistik.volumen[0].summe }}<v-spacer></v-spacer
                        ></v-card-title>
                        <v-card-title class="pa-0 caption"
                          ><v-spacer></v-spacer>Liter<v-spacer></v-spacer
                        ></v-card-title>
                      </v-card>
                      <v-divider></v-divider>
                    </v-col>
                    <v-col cols="12" class="px-1">
                      <v-card class="mb-1" flat>
                        <v-card-title class="pa-0 pt-2 overline"
                          ><v-spacer></v-spacer><v-badge dot inline left color="tertiary">Softdrinks</v-badge
                          ><v-spacer></v-spacer
                        ></v-card-title>
                        <v-card-title class="pa-0"
                          ><v-spacer></v-spacer>{{ jahrStatistik.volumen[1].summe }}<v-spacer></v-spacer
                        ></v-card-title>
                        <v-card-title class="pa-0 caption"
                          ><v-spacer></v-spacer>Liter<v-spacer></v-spacer
                        ></v-card-title>
                      </v-card>
                      <v-divider></v-divider>
                    </v-col>
                    <v-col cols="12" class="px-1">
                      <v-card class="mb-1" flat>
                        <v-card-title class="pa-0 pt-2 overline"
                          ><v-spacer></v-spacer><v-badge dot inline left color="amber">Wein & Schnaps</v-badge
                          ><v-spacer></v-spacer
                        ></v-card-title>
                        <v-card-title class="pa-0"
                          ><v-spacer></v-spacer>{{ jahrStatistik.volumen[2].summe }}<v-spacer></v-spacer
                        ></v-card-title>
                        <v-card-title class="pa-0 caption"
                          ><v-spacer></v-spacer>Liter<v-spacer></v-spacer
                        ></v-card-title>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="8">
                  <apexchart
                    height="291px"
                    type="donut"
                    :options="jahrStatistik.volumen.chartOptions"
                    :series="jahrStatistik.volumen.donut.series"
                  ></apexchart>
                </v-col>
              </v-row>
              <apexchart height="200" type="bar" :options="options" :series="jahrStatistik.volumen"></apexchart>
            </v-card>
          </v-col>
          <v-col order="3" order-md="6" cols="12" md="3" class="px-1">
            <v-card class="mb-1 pa-2 pt-1" outlined height="100%">
              <v-virtual-scroll
                height="250"
                bench="2"
                item-height="36"
                :items="jahrStatistik.verbrauchSoftdrinks"
                class="mt-1"
              >
                <template v-slot:default="{ item }">
                  <v-progress-linear
                    rounded
                    height="32"
                    :value="(item.liter / jahrStatistik.volumen[1].summe) * 100"
                    :color="
                      (item.liter / jahrStatistik.volumen[1].summe) * 100 > 25
                        ? 'red'
                        : (item.liter / jahrStatistik.volumen[1].summe) * 100 > 20
                        ? 'red lighten-1'
                        : (item.liter / jahrStatistik.volumen[1].summe) * 100 > 10
                        ? 'red lighten-2'
                        : (item.liter / jahrStatistik.volumen[1].summe) * 100 > 5
                        ? 'red lighten-3'
                        : 'red lighten-4'
                    "
                  >
                    <v-row no-gutters class="mx-2">
                      <v-col cols="6" class="text-truncate">{{ item.bezeichnung }}</v-col>
                      <v-col cols="4" class="text-center"
                        ><strong>{{ ((item.liter / jahrStatistik.volumen[1].summe) * 100).toFixed(1) }}%</strong></v-col
                      >
                      <v-col cols="2" class="text-right">{{ item.liter }} l</v-col>
                    </v-row>
                  </v-progress-linear>
                </template>
              </v-virtual-scroll>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <!------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
      ------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
      ------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------

      
      Jahres Statistik XL Version

      ------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
      ------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
      ----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------->
      <v-col cols="12" v-if="monatSelect === 12" class="hidden-lg-and-down">
        <v-row no-gutters>
          <v-col cols="2" class="px-1 mb-1">
            <v-card class="mb-1" outlined height="100%">
              <v-card-title class="pa-0 overline"><v-spacer></v-spacer>an der Theke<v-spacer></v-spacer></v-card-title>
              <v-card-title class="pa-0 px-4 subtitle-2"
                ><v-spacer></v-spacer>{{ jahrStatistik.bestenliste.length }} BbrBbr<v-spacer></v-spacer
              ></v-card-title>
              <v-card-title class="pa-0 px-4 subtitle-2"
                ><v-spacer></v-spacer>{{ jahrStatistik.tageAnDerTheke }} Tage<v-spacer></v-spacer
              ></v-card-title>
              <v-card-title class="pa-0 px-4 pt-2 subtitle-2"
                ><v-spacer></v-spacer>{{ $filters.date(jahrStatistik.besterTag.datum, "DD.MM.YYYY")
                }}<v-spacer></v-spacer
              ></v-card-title>
              <v-card-title class="pa-0 px-4 subtitle-2"
                ><v-spacer></v-spacer>{{ jahrStatistik.besterTag.anzahl }} Striche<v-spacer></v-spacer
              ></v-card-title>
            </v-card>
          </v-col>
          <v-col cols="2" class="px-1 mb-1">
            <v-tooltip bottom color="orange" min-width="250px">
              <template v-slot:activator="{ on }">
                <v-card class="mb-1" outlined height="100%" v-on="on">
                  <v-card-title class="pa-0 overline"><v-spacer></v-spacer>Striche<v-spacer></v-spacer></v-card-title>
                  <v-card-title class="pa-0 px-4 subtitle-2"
                    >Striche<v-spacer></v-spacer>{{ jahrStatistik.gesamtStriche.summe }} ({{
                      ((jahrStatistik.gesamtStriche.summe / jahrStatistik.gesamtStricheTheorie.summe) * 100).toFixed(1)
                    }}
                    %)</v-card-title
                  >
                  <v-card-title class="pa-0 px-4 subtitle-2"
                    >Striche EKP<v-spacer></v-spacer
                    >{{ jahrStatistik.gesamtStrichePraxis.summe - jahrStatistik.gesamtStriche.summe }} ({{
                      (
                        ((jahrStatistik.gesamtStrichePraxis.summe - jahrStatistik.gesamtStriche.summe) /
                          jahrStatistik.gesamtStricheTheorie.summe) *
                        100
                      ).toFixed(1)
                    }}
                    %)</v-card-title
                  >
                  <v-card-title class="pa-0 px-4 subtitle-2"
                    >Schankverlust<v-spacer></v-spacer
                    >{{ jahrStatistik.gesamtStricheTheorie.summe - jahrStatistik.gesamtStrichePraxis.summe }} ({{
                      (
                        100 -
                        (jahrStatistik.gesamtStrichePraxis.summe / jahrStatistik.gesamtStricheTheorie.summe) * 100
                      ).toFixed(1)
                    }}
                    %)</v-card-title
                  >
                  <v-card-title class="pa-0 px-4"
                    ><v-spacer></v-spacer>{{ jahrStatistik.gesamtStricheTheorie.summe }}</v-card-title
                  >
                </v-card>
              </template>
              <v-card flat class="transparent" dark>
                <v-card-title class="pa-0 overline"
                  ><v-spacer></v-spacer>Anzahl Striche an Gesamtvolumen<v-spacer></v-spacer
                ></v-card-title>
                <v-card-title class="pa-0 subtitle-2">
                  <v-progress-linear
                    v-for="(item, index) in jahrStatistik.gesamtStriche.data"
                    :key="index"
                    rounded
                    height="17"
                    :value="((item / jahrStatistik.gesamtStricheTheorie.data[index]) * 100).toFixed(1)"
                    color="tertiary"
                    class="mb-1"
                  >
                    <v-row no-gutters class="mx-2">
                      <v-col cols="6" class="caption text-truncate">{{
                        $filters.date(new Date(jahre[jahrSelect], index), "MM.YY")
                      }}</v-col>
                      <v-col cols="6" class="caption text-right">
                        {{ ((item / jahrStatistik.gesamtStricheTheorie.data[index]) * 100).toFixed(1) }} %
                      </v-col>
                    </v-row>
                  </v-progress-linear>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-title class="pa-0">
                  <v-progress-linear
                    rounded
                    height="28"
                    :value="
                      ((jahrStatistik.gesamtStriche.summe / jahrStatistik.gesamtStricheTheorie.summe) * 100).toFixed(1)
                    "
                    color="tertiary"
                    class="my-1"
                  >
                    <v-row no-gutters class="mx-2">
                      <v-col cols="12" class="title text-right">
                        {{
                          (
                            (jahrStatistik.gesamtStriche.summe / jahrStatistik.gesamtStricheTheorie.summe) *
                            100
                          ).toFixed(1)
                        }}
                        %
                      </v-col>
                    </v-row>
                  </v-progress-linear>
                </v-card-title>
              </v-card>
            </v-tooltip>
          </v-col>
          <v-col cols="2" class="px-1 mb-1">
            <v-tooltip bottom color="orange" min-width="250px">
              <template v-slot:activator="{ on }">
                <v-card class="mb-1" outlined height="100%" v-on="on">
                  <v-card-title class="pa-0 overline"
                    ><v-spacer></v-spacer>Schankverlust<v-spacer></v-spacer
                  ></v-card-title>
                  <v-card-title class="pa-0"
                    ><v-spacer></v-spacer>{{ jahrStatistik.schankverlust.gesamt }} %<v-spacer></v-spacer
                  ></v-card-title>
                  <v-card-title class="pa-0 subtitle-2"
                    ><v-spacer></v-spacer>{{ jahrStatistik.schankverlust.preis | money }}<v-spacer></v-spacer
                  ></v-card-title>
                </v-card>
              </template>
              <v-card flat class="transparent" dark>
                <v-card-title class="pa-0 overline"
                  ><v-spacer></v-spacer>Schankverlust<v-spacer></v-spacer
                ></v-card-title>
                <v-card-title class="pa-0 subtitle-2">
                  <v-progress-linear
                    v-for="(item, index) in jahrStatistik.schankverlust.data"
                    :key="index"
                    rounded
                    height="17"
                    :value="(item / 50) * 100"
                    color="tertiary"
                    class="mb-1"
                  >
                    <v-row no-gutters class="mx-2">
                      <v-col cols="6" class="caption text-truncate">{{
                        $filters.date(new Date(jahre[jahrSelect], index), "MM.YYYY")
                      }}</v-col>
                      <v-col cols="6" class="caption text-right">{{ item }} %</v-col>
                    </v-row>
                  </v-progress-linear>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-title class="pa-0">
                  <v-progress-linear
                    rounded
                    height="28"
                    :value="(jahrStatistik.schankverlust.gesamt / 50) * 100"
                    color="tertiary"
                    class="my-1"
                  >
                    <v-row no-gutters class="mx-2">
                      <v-col cols="6" class="caption text-truncate"></v-col>
                      <v-col cols="6" class="title text-right">{{ jahrStatistik.schankverlust.gesamt }} %</v-col>
                    </v-row>
                  </v-progress-linear>
                </v-card-title>
              </v-card>
            </v-tooltip>
          </v-col>
          <v-col cols="2" class="px-1 mb-1">
            <v-card class="mb-1" outlined height="100%">
              <v-card-title class="pa-0 overline"
                ><v-spacer></v-spacer>Couleurstriche<v-spacer></v-spacer
              ></v-card-title>
              <v-card-title class="pa-0"
                ><v-spacer></v-spacer>{{ jahrStatistik.couleurstriche }} Striche<v-spacer></v-spacer
              ></v-card-title>
              <v-card-title class="pa-0"
                ><v-spacer></v-spacer>{{ jahrStatistik.oettingerKisten.summe }} Ötti-Kisten<v-spacer></v-spacer
              ></v-card-title>
              <v-card-title class="pa-0 subtitle-2"
                ><v-spacer></v-spacer
                >{{ (jahrStatistik.oettingerKisten.preis + jahrStatistik.couleurstrichePreis) | money
                }}<v-spacer></v-spacer
              ></v-card-title>
            </v-card>
          </v-col>
          <v-col cols="2" class="px-1 mb-1">
            <v-tooltip bottom color="orange" min-width="250px">
              <template v-slot:activator="{ on }">
                <v-card class="mb-1" outlined height="100%" v-on="on">
                  <v-card-title class="pa-0 overline"><v-spacer></v-spacer>Einkauf<v-spacer></v-spacer></v-card-title>
                  <v-card-title class="pa-0 px-4 subtitle-2"
                    >Bier Schneider<v-spacer></v-spacer>{{ jahrStatistik.einkauf.bierschneider | money }}</v-card-title
                  >
                  <v-card-title class="pa-0 px-4 subtitle-2"
                    >Metro<v-spacer></v-spacer>{{ jahrStatistik.einkauf.metro | money }}</v-card-title
                  >
                  <v-card-title class="pa-0 px-4 subtitle-2"
                    >Oettinger<v-spacer></v-spacer>{{ jahrStatistik.einkauf.oettinger | money }}</v-card-title
                  >
                  <v-card-title class="pa-0 px-4"
                    ><v-spacer></v-spacer>{{ jahrStatistik.einkauf.summe | money }}</v-card-title
                  >
                </v-card>
              </template>
              <v-card flat class="transparent" dark>
                <v-card-title class="pa-0 overline"
                  ><v-spacer></v-spacer>Einkauf nach Lieferant<v-spacer></v-spacer
                ></v-card-title>
                <v-card-title class="pa-0 subtitle-2"
                  >Bier Schneider<v-spacer></v-spacer>{{ jahrStatistik.einkauf.bierschneider | money }}</v-card-title
                >
                <v-card-title class="pa-0 subtitle-2"
                  >Metro<v-spacer></v-spacer>{{ jahrStatistik.einkauf.metro | money }}</v-card-title
                >
                <v-card-title class="pa-0 subtitle-2"
                  >Oettinger<v-spacer></v-spacer>{{ jahrStatistik.einkauf.oettinger | money }}</v-card-title
                >
                <v-card-title class="pa-0 subtitle-2"
                  >Rewe<v-spacer></v-spacer>{{ jahrStatistik.einkauf.rewe | money }}</v-card-title
                >
                <v-card-title class="pa-0 subtitle-2"
                  >Vendel<v-spacer></v-spacer>{{ jahrStatistik.einkauf.vendel | money }}</v-card-title
                >
                <v-card-title class="pa-0 subtitle-2"
                  >Vinos<v-spacer></v-spacer>{{ jahrStatistik.einkauf.vinos | money }}</v-card-title
                >
                <v-divider></v-divider>
                <v-card-title class="pa-0"><v-spacer></v-spacer>{{ jahrStatistik.einkauf.summe | money }}</v-card-title>
              </v-card>
            </v-tooltip>
          </v-col>
          <v-col cols="2" class="px-1 mb-1">
            <v-tooltip bottom color="orange" min-width="250px">
              <template v-slot:activator="{ on }">
                <v-card class="mb-1" outlined height="100%" v-on="on">
                  <v-card-title class="pa-0 overline"><v-spacer></v-spacer>Umsatz<v-spacer></v-spacer></v-card-title>
                  <v-card-title class="pa-0 px-4 subtitle-2"
                    >Striche<v-spacer></v-spacer>{{ jahrStatistik.umsatz.striche | money }}</v-card-title
                  >
                  <v-card-title class="pa-0 px-4 subtitle-2"
                    >EKP<v-spacer></v-spacer>{{ jahrStatistik.umsatz.ekp | money }}</v-card-title
                  >
                  <v-card-title class="pa-0 px-4 subtitle-2"
                    >Pauschal<v-spacer></v-spacer>{{ jahrStatistik.umsatz.pauschal | money }}</v-card-title
                  >
                  <v-card-title class="pa-0 px-4"
                    ><v-spacer></v-spacer>{{ jahrStatistik.umsatz.summe | money }}</v-card-title
                  >
                </v-card>
              </template>
              <v-card flat class="transparent" dark>
                <v-card-title class="pa-0 overline"
                  ><v-spacer></v-spacer>Davon gingen Rechnungen an<v-spacer></v-spacer
                ></v-card-title>
                <v-card-title class="pa-0 px-4 subtitle-2"
                  >Bierspenden<v-spacer></v-spacer>{{ jahrStatistik.umsatz.bierkasse | money }}</v-card-title
                >
                <v-card-title class="pa-0 px-4 subtitle-2"
                  >Aktivenkasse<v-spacer></v-spacer>{{ jahrStatistik.umsatz.aktivenkasse | money }}</v-card-title
                >
                <v-card-title class="pa-0 px-4 subtitle-2"
                  >Fuxenkasse<v-spacer></v-spacer>{{ jahrStatistik.umsatz.ahv | money }}</v-card-title
                >
                <v-card-title class="pa-0 px-4 subtitle-2"
                  >AHV<v-spacer></v-spacer>{{ jahrStatistik.umsatz.hbv | money }}</v-card-title
                >
                <v-card-title class="pa-0 px-4 subtitle-2"
                  >HBV<v-spacer></v-spacer>{{ jahrStatistik.umsatz.fuxia | money }}</v-card-title
                >
                <v-card-title class="pa-0 px-4 subtitle-2"
                  >Couleur<v-spacer></v-spacer>{{ jahrStatistik.umsatz.couleur | money }}</v-card-title
                >
                <v-divider></v-divider>
                <v-card-title class="pa-0 px-4"
                  ><v-spacer></v-spacer>
                  {{
                    (jahrStatistik.umsatz.bierkasse +
                      jahrStatistik.umsatz.aktivenkasse +
                      jahrStatistik.umsatz.ahv +
                      jahrStatistik.umsatz.hbv +
                      jahrStatistik.umsatz.fuxia +
                      jahrStatistik.umsatz.couleur)
                      | money
                  }}
                </v-card-title>
              </v-card>
            </v-tooltip>
          </v-col>
          <v-col cols="2" class="px-1 mb-1">
            <v-card class="mb-1 pa-2 pt-1" outlined height="100%">
              <v-virtual-scroll
                height="228"
                bench="2"
                item-height="36"
                :items="jahrStatistik.verbrauchBierSorte"
                class="mt-1"
              >
                <template v-slot:default="{ item, index }">
                  <v-progress-linear
                    rounded
                    height="32"
                    :value="jahrStatistik.verbrauchBier.donut.series[index]"
                    :color="
                      jahrStatistik.verbrauchBier.donut.series[index] > 50
                        ? 'primary'
                        : jahrStatistik.verbrauchBier.donut.series[index] > 25
                        ? 'primary lighten-1'
                        : jahrStatistik.verbrauchBier.donut.series[index] > 10
                        ? 'primary lighten-2'
                        : jahrStatistik.verbrauchBier.donut.series[index] > 5
                        ? 'primary lighten-3'
                        : 'primary lighten-4'
                    "
                  >
                    <v-row no-gutters class="mx-2">
                      <v-col cols="4">{{ item.Id }}</v-col>
                      <v-col cols="4" class="text-center"
                        ><strong>{{ jahrStatistik.verbrauchBier.donut.series[index] }}%</strong></v-col
                      >
                      <v-col cols="4" class="text-right">{{ item.liter }} l</v-col>
                    </v-row>
                  </v-progress-linear>
                </template>
              </v-virtual-scroll>
            </v-card>
          </v-col>
          <v-col cols="3" class="px-1 mb-1">
            <v-card outlined>
              <v-row no-gutters>
                <v-col cols="4">
                  <v-row no-gutters>
                    <v-col cols="12" class="px-1">
                      <v-card class="mb-1 mt-1" flat>
                        <v-card-title class="pa-0 pt-5 overline"
                          ><v-spacer></v-spacer><v-badge dot inline left color="primary">Bier</v-badge
                          ><v-spacer></v-spacer
                        ></v-card-title>
                        <v-card-title class="pa-0"
                          ><v-spacer></v-spacer>{{ jahrStatistik.volumen[0].summe }}<v-spacer></v-spacer
                        ></v-card-title>
                        <v-card-title class="pa-0 caption"
                          ><v-spacer></v-spacer>Liter<v-spacer></v-spacer
                        ></v-card-title>
                      </v-card>
                      <v-divider></v-divider>
                    </v-col>
                    <v-col cols="12" class="px-1">
                      <v-card class="mb-1" flat>
                        <v-card-title class="pa-0 pt-2 overline"
                          ><v-spacer></v-spacer><v-badge dot inline left color="tertiary">Softdrinks</v-badge
                          ><v-spacer></v-spacer
                        ></v-card-title>
                        <v-card-title class="pa-0"
                          ><v-spacer></v-spacer>{{ jahrStatistik.volumen[1].summe }}<v-spacer></v-spacer
                        ></v-card-title>
                        <v-card-title class="pa-0 caption"
                          ><v-spacer></v-spacer>Liter<v-spacer></v-spacer
                        ></v-card-title>
                      </v-card>
                      <v-divider></v-divider>
                    </v-col>
                    <v-col cols="12" class="px-1">
                      <v-card class="mb-1" flat>
                        <v-card-title class="pa-0 pt-2 overline"
                          ><v-spacer></v-spacer><v-badge dot inline left color="amber">Wein & Schnaps</v-badge
                          ><v-spacer></v-spacer
                        ></v-card-title>
                        <v-card-title class="pa-0"
                          ><v-spacer></v-spacer>{{ jahrStatistik.volumen[2].summe }}<v-spacer></v-spacer
                        ></v-card-title>
                        <v-card-title class="pa-0 caption"
                          ><v-spacer></v-spacer>Liter<v-spacer></v-spacer
                        ></v-card-title>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="8">
                  <apexchart
                    height="267px"
                    type="donut"
                    :options="jahrStatistik.volumen.chartOptions"
                    :series="jahrStatistik.volumen.donut.series"
                  ></apexchart>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
          <v-col cols="3" class="px-1 mb-1">
            <v-card outlined height="100%">
              <apexchart height="231" type="bar" :options="options" :series="jahrStatistik.volumen"></apexchart>
            </v-card>
          </v-col>
          <v-col cols="2" class="px-1 mb-1">
            <v-card outlined class="mb-1 pa-2 pt-1" height="100%">
              <v-virtual-scroll
                height="228"
                bench="2"
                item-height="19"
                :items="jahrStatistik.stricheProTag"
                class="mt-1"
              >
                <template v-slot:default="{ item, index }">
                  <v-progress-linear
                    rounded
                    height="17"
                    :value="(item.summe / jahrStatistik.stricheProTagMax) * 100"
                    color="primary lighten-2"
                  >
                    <v-row no-gutters class="mx-2">
                      <v-col cols="6" class="caption text-truncate">{{
                        $filters.date(new Date(jahre[jahrSelect], index), "MM.YYYY")
                      }}</v-col>
                      <v-col cols="6" class="caption text-right">{{ item.summe }} Striche</v-col>
                    </v-row>
                  </v-progress-linear>
                </template>
              </v-virtual-scroll>
            </v-card>
          </v-col>
          <v-col cols="2" class="px-1 mb-1">
            <v-card class="mb-1 pa-2 pt-1" outlined height="100%">
              <v-virtual-scroll
                height="228"
                bench="2"
                item-height="36"
                :items="jahrStatistik.verbrauchSoftdrinks"
                class="mt-1"
              >
                <template v-slot:default="{ item }">
                  <v-progress-linear
                    rounded
                    height="32"
                    :value="(item.liter / jahrStatistik.volumen[1].summe) * 100"
                    :color="
                      (item.liter / jahrStatistik.volumen[1].summe) * 100 > 25
                        ? 'red'
                        : (item.liter / jahrStatistik.volumen[1].summe) * 100 > 20
                        ? 'red lighten-1'
                        : (item.liter / jahrStatistik.volumen[1].summe) * 100 > 10
                        ? 'red lighten-2'
                        : (item.liter / jahrStatistik.volumen[1].summe) * 100 > 5
                        ? 'red lighten-3'
                        : 'red lighten-4'
                    "
                  >
                    <v-row no-gutters class="mx-2">
                      <v-col cols="6" class="text-truncate">{{ item.bezeichnung }}</v-col>
                      <v-col cols="4" class="text-center"
                        ><strong>{{ ((item.liter / jahrStatistik.volumen[1].summe) * 100).toFixed(1) }}%</strong></v-col
                      >
                      <v-col cols="2" class="text-right">{{ item.liter }} l</v-col>
                    </v-row>
                  </v-progress-linear>
                </template>
              </v-virtual-scroll>
            </v-card>
          </v-col>

          <v-col cols="12" md="4" class="px-1">
            <v-card outlined class="mb-2">
              <v-card-title class="justify-center py-1">Preise</v-card-title>
              <v-simple-table fixed-header height="300px" dense>
                <thead>
                  <tr>
                    <th class="text-left"></th>
                    <th class="text-right">Strich</th>
                    <th class="text-right">EKP</th>
                    <th class="text-right">Schankverlust</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="text-left">Kosten pro Strich</td>
                    <td class="text-right">{{ preiskalkulation.kostenStriche | money }}</td>
                    <td class="text-right">{{ preiskalkulation.kostenEKP | money }}</td>
                    <td class="text-right">{{ preiskalkulation.kostenSchankverlust | money }}</td>
                  </tr>
                  <tr>
                    <td class="text-left">Einnahmen pro Strich</td>
                    <td class="text-right">{{ preiskalkulation.einnahmenStriche | money }}</td>
                    <td class="text-right">{{ preiskalkulation.einnahmenEKP | money }}</td>
                    <td class="text-right">{{ preiskalkulation.einnahmenSchankverlust | money }}</td>
                  </tr>
                  <tr>
                    <td class="text-left">Gewinn pro Strich</td>
                    <td class="text-right">{{ preiskalkulation.gewinnStriche | money }}</td>
                    <td class="text-right">{{ preiskalkulation.gewinnEKP | money }}</td>
                    <td class="text-right">{{ preiskalkulation.gewinnSchankverlust | money }}</td>
                  </tr>
                  <tr>
                    <td class="text-left">Anzahl Striche</td>
                    <td class="text-right">{{ jahrStatistik.gesamtStriche.summe }}</td>
                    <td class="text-right">
                      {{ jahrStatistik.gesamtStrichePraxis.summe - jahrStatistik.gesamtStriche.summe }}
                    </td>
                    <td class="text-right">
                      {{ jahrStatistik.gesamtStricheTheorie.summe - jahrStatistik.gesamtStrichePraxis.summe }}
                    </td>
                  </tr>
                  <tr>
                    <td class="text-left">Gewinn</td>
                    <td class="text-right">
                      {{ (preiskalkulation.gewinnStriche * jahrStatistik.gesamtStriche.summe) | money }}
                    </td>
                    <td class="text-right">
                      {{
                        (preiskalkulation.gewinnEKP *
                          (jahrStatistik.gesamtStrichePraxis.summe - jahrStatistik.gesamtStriche.summe))
                          | money
                      }}
                    </td>
                    <td class="text-right">
                      {{
                        (preiskalkulation.gewinnSchankverlust *
                          (jahrStatistik.gesamtStricheTheorie.summe - jahrStatistik.gesamtStrichePraxis.summe))
                          | money
                      }}
                    </td>
                  </tr>
                  <tr class="font-weight-bold mt-4">
                    <td class="text-left">Summe</td>
                    <td class="text-right"></td>
                    <td class="text-right"></td>
                    <td class="text-right">
                      {{
                        (preiskalkulation.gewinnStriche * jahrStatistik.gesamtStriche.summe +
                          preiskalkulation.gewinnEKP *
                            (jahrStatistik.gesamtStrichePraxis.summe - jahrStatistik.gesamtStriche.summe) +
                          preiskalkulation.gewinnSchankverlust *
                            (jahrStatistik.gesamtStricheTheorie.summe - jahrStatistik.gesamtStrichePraxis.summe))
                          | money
                      }}
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-card>
          </v-col>

          <v-col cols="12" md="4" class="px-1">
            <v-card outlined class="mb-2">
              <v-card-title class="justify-center py-1">Bier</v-card-title>
              <v-simple-table fixed-header height="300px" dense>
                <thead>
                  <tr>
                    <th class="text-left">Bezeichnung</th>
                    <th class="text-center">EKP</th>
                    <th class="text-center">Verbraucht</th>
                    <th class="text-center">EK-Preis</th>
                    <th class="text-center">VK-Preis</th>
                    <th class="text-center">VK-Striche</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in jahrStatistik.verbrauchBier" :key="item.bezeichnung">
                    <td class="text-left">{{ item.bezeichnung }}</td>
                    <td class="text-right">{{ item.ekp }}</td>
                    <td class="text-right">{{ item.anzahl }}</td>
                    <td v-if="item.getrank" class="text-right">{{ item.getrank.preis | money }}</td>
                    <td v-if="item.getrank" class="text-right">{{ item.getrank.verkauf1 | money }}</td>
                    <td v-if="item.getrank" class="text-right">{{ item.getrank.striche }}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-card>
          </v-col>

          <v-col cols="12" md="4" class="px-1">
            <v-card outlined class="mb-2">
              <v-card-title class="justify-center py-1">Softdrinks</v-card-title>
              <v-simple-table fixed-header height="300px" dense>
                <thead>
                  <tr>
                    <th class="text-left">Bezeichnung</th>
                    <th class="text-center">EKP</th>
                    <th class="text-center">Verbraucht</th>
                    <th class="text-center">EK-Preis</th>
                    <th class="text-center">VK-Preis</th>
                    <th class="text-center">VK-Striche</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in jahrStatistik.verbrauchSoftdrinks" :key="item.bezeichnung">
                    <td class="text-left">{{ item.bezeichnung }}</td>
                    <td class="text-right">{{ item.ekp }}</td>
                    <td class="text-right">{{ item.anzahl }}</td>
                    <td v-if="item.getrank" class="text-right">{{ item.getrank.preis | money }}</td>
                    <td v-if="item.getrank" class="text-right">{{ item.getrank.verkauf1 | money }}</td>
                    <td v-if="item.getrank" class="text-right">{{ item.getrank.striche }}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-card>
          </v-col>

          <v-col cols="12" md="4" class="px-1">
            <v-card outlined class="mb-2">
              <v-card-title class="justify-center py-1">Wein & Schnaps</v-card-title>
              <v-simple-table fixed-header height="300px" dense>
                <thead>
                  <tr>
                    <th class="text-left">Bezeichnung</th>
                    <th class="text-center">EKP</th>
                    <th class="text-center">Verbraucht</th>
                    <th class="text-center">EK-Preis</th>
                    <th class="text-center">VK-Preis</th>
                    <th class="text-center">VK-Striche</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in jahrStatistik.verbrauchWeinSchnaps" :key="item.bezeichnung">
                    <td class="text-left">{{ item.bezeichnung }}</td>
                    <td class="text-right">{{ item.ekp }}</td>
                    <td class="text-right">{{ item.anzahl }}</td>
                    <td v-if="item.getrank" class="text-right">{{ item.getrank.preis | money }}</td>
                    <td v-if="item.getrank" class="text-right">{{ item.getrank.verkauf1 | money }}</td>
                    <td v-if="item.getrank" class="text-right">{{ item.getrank.striche }}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-card>
          </v-col>

          <v-col cols="2" class="px-1 mb-1">
            <v-card>
              <v-card-title class="justify-center py-1">Vermögen</v-card-title>
              <v-card-text class="pa-1">
                <!-- <v-progress-linear
                  v-for="(item, index) in jahrStatistik.vermogen"
                  :key="index"
                  rounded
                  height="19"
                  :value="(item / Math.max(...jahrStatistik.vermogen)) * 100"
                  class="mb-1"
                >
                  <v-row no-gutters class="mx-2 caption">
                    <v-col cols="2">{{ $filters.date(jahre[jahrSelect] + "-" + monate[index], "MM") }}</v-col>
                    <v-col cols="7" class="text-right">{{ item | money }}</v-col>
                    <v-col
                      cols="3"
                      class="text-right"
                      v-if="index > 0 && jahrStatistik.vermogen[index - 1] && jahrStatistik.vermogen[index]"
                      >{{
                        ((jahrStatistik.vermogen[index] / jahrStatistik.vermogen[index - 1]) * 100 - 100).toFixed(0)
                      }}
                      %</v-col
                    >
                  </v-row>
                </v-progress-linear> -->
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="4" class="px-1 mb-1">
            <v-card outlined height="100%">
              <v-row no-gutters class="px-1 mx-4 mt-4">
                <v-col cols="4" class="mt-4 px-1">
                  <v-card outlined height="100%" class="grey lighten-2">
                    <v-card-title class="pa-0 pt-2 overline"
                      ><v-spacer></v-spacer><v-icon size="48" class="grey--text lighten-1">emoji_events</v-icon
                      ><v-spacer></v-spacer
                    ></v-card-title>
                    <v-card-title class="pa-0 pt-3 overline"
                      ><v-spacer></v-spacer>2. Platz<v-spacer></v-spacer
                    ></v-card-title>
                    <v-card-title class="pa-0 subtitle-2 text-truncate"
                      ><v-spacer></v-spacer>{{ $filters.user(jahrStatistik.bestenliste[1].bbr, bbrbbr)
                      }}<v-spacer></v-spacer
                    ></v-card-title>
                    <v-card-title class="pa-0 pb-2 caption"
                      ><v-spacer></v-spacer>{{ jahrStatistik.bestenliste[1].anzahl }} Striche<v-spacer></v-spacer
                    ></v-card-title>
                  </v-card>
                </v-col>
                <v-col cols="4" class="px-1 mt-1">
                  <v-card outlined height="100%" class="amber lighten-4">
                    <v-card-title class="pa-0 pt-2 overline"
                      ><v-spacer></v-spacer><v-icon size="48" class="amber--text lighten-1">emoji_events</v-icon
                      ><v-spacer></v-spacer
                    ></v-card-title>
                    <v-card-title class="pa-0 pt-6 overline"
                      ><v-spacer></v-spacer>1. Platz<v-spacer></v-spacer
                    ></v-card-title>
                    <v-card-title class="pa-0 subtitle-2 text-truncate"
                      ><v-spacer></v-spacer>{{ $filters.user(jahrStatistik.bestenliste[0].bbr, bbrbbr)
                      }}<v-spacer></v-spacer
                    ></v-card-title>
                    <v-card-title class="pa-0 pb-2 caption"
                      ><v-spacer></v-spacer>{{ jahrStatistik.bestenliste[0].anzahl }} Striche<v-spacer></v-spacer
                    ></v-card-title>
                  </v-card>
                </v-col>
                <v-col cols="4" class="px-1 mt-7">
                  <v-card outlined height="100%" class="deep-orange lighten-5">
                    <v-card-title class="pa-0 pt-2 overline"
                      ><v-spacer></v-spacer><v-icon size="48" class="deep-orange--text darken-3">emoji_events</v-icon
                      ><v-spacer></v-spacer
                    ></v-card-title>
                    <v-card-title class="pa-0 overline"
                      ><v-spacer></v-spacer>3. Platz<v-spacer></v-spacer
                    ></v-card-title>
                    <v-card-title class="pa-0 subtitle-2 text-truncate"
                      ><v-spacer></v-spacer>{{ $filters.user(jahrStatistik.bestenliste[2].bbr, bbrbbr)
                      }}<v-spacer></v-spacer
                    ></v-card-title>
                    <v-card-title class="pa-0 pb-2 caption"
                      ><v-spacer></v-spacer>{{ jahrStatistik.bestenliste[2].anzahl }} Striche<v-spacer></v-spacer
                    ></v-card-title>
                  </v-card>
                </v-col>
              </v-row>
              <v-simple-table fixed-header dense height="152px" class="mt-6">
                <tbody>
                  <tr v-for="(item, index) in jahrStatistik.bestenliste" :key="item.bbr" v-if="index > 2">
                    <td width="30px"><v-icon>military_tech</v-icon></td>
                    <td width="30px">{{ index + 1 }}.</td>
                    <td>{{ $filters.user(item.bbr, bbrbbr) }}</td>
                    <td width="30px">{{ item.anzahl }}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="4" offset="4" v-else>
        <v-alert type="info" v-for="(item, index) in errorMessage" :key="index">
          {{ item[1] }}
        </v-alert>
        <v-alert type="warning" outlined border="left">
          Die Statistik kann erst erstellt werden, wenn die Getränkezählung von Monatsanfang und Monatsende vorliegen.
        </v-alert>
        <v-btn block :disabled="!zahlungExist" @click="addMonat(true)">Monat berechnen</v-btn>
      </v-col>
    </v-row>

    <v-dialog v-model="showDebug" width="80%" :fullscreen="$vuetify.breakpoint.smAndDown" persistent scrollable>
      <v-card class="pa-0 ma-0">
        <v-card-title class="green">
          Debug Fenster
          <v-spacer></v-spacer>
          <v-btn icon @click="showDebug = false"><v-icon>close</v-icon></v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-0 ma-0">
          <v-row>
            <v-col cols="6">
              <v-simple-table fixed-header height="100%" dense>
                <thead>
                  <tr>
                    <th>Key</th>
                    <th>Data</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, key) in statistik" :key="key">
                    <td>{{ key }}</td>
                    <td v-if="Array.isArray(item)">
                      <v-list dense>
                        <v-list-item v-for="(item2, index) in item" :key="index">
                          <v-list-item-icon>{{ index + 1 }}.</v-list-item-icon>
                          <v-list-item-content>{{ item2 }}</v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </td>
                    <td v-else>{{ item }}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-col>
            <v-col cols="6">
              <v-simple-table fixed-header height="100%" dense>
                <thead>
                  <tr>
                    <th>Key</th>
                    <th>Data</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, key) in jahrStatistik" :key="key">
                    <td>{{ key }}</td>
                    <td v-if="Array.isArray(item)">
                      <v-list dense>
                        <v-list-item v-for="(item2, index) in item" :key="index">
                          <v-list-item-icon>{{ index + 1 }}.</v-list-item-icon>
                          <v-list-item-content>{{ item2 }}</v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </td>
                    <td v-else>{{ item }}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  export default {
    data() {
      return {
        ekpInSchankverlust: false,
        showSchankverlustData: false,
        showNurBbrBbr: true,
        showArray: "schankverlust",
        showDebug: false,
        monate: ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"],
        monatSelect: "",
        jahrSelect: "",
        filterVon: "2022-02-01",
        filterBis: "2022-03-01",
        series: [{ name: "" }],
        gesamtvermogen: {},
        errorMessage: "Error",
        options: {
          chart: {
            toolbar: {
              tools: {
                download: true,
                selection: false,
                zoom: false,
                zoomin: false,
                zoomout: false,
                pan: false,
                reset: false,
                customIcons: [],
              },
            },
            type: "bar",
            stacked: true,
          },
          dataLabels: { enabled: false },
          colors: ["#254fb3", "#EF5350", "#FFC107"],
          stroke: { width: 0 },
          tooltip: {
            y: {
              formatter: function (val, index) {
                return val.toFixed(0);
              },
            },
          },
          yaxis: {
            min: 0,
            tickAmount: 5,
            title: { text: undefined },
            labels: {
              formatter: function (val, index) {
                return val.toFixed(0);
              },
            },
          },
          xaxis: {
            title: { text: undefined },
          },
          fill: {
            colors: ["#254fb3", "#EF5350", "#FFC107"],
            opacity: 1,
            type: "solid",
          },
          legend: { show: false },
        },
        options2: {
          chart: {
            width: "100%",
            toolbar: {
              tools: {
                download: false,
                selection: false,
                zoom: false,
                zoomin: false,
                zoomout: false,
                pan: false,
                reset: false,
                customIcons: [],
              },
            },
          },
          dataLabels: { enabled: false },
          stroke: { width: 0 },
          yaxis: {
            min: 0,
            labels: { show: false },
          },
          grid: {
            padding: {
              top: 0,
              right: 0,
              bottom: 0,
              left: 0,
            },
            xaxis: { lines: { show: false } },
            yaxis: { lines: { show: false } },
          },
          xaxis: {
            labels: { show: false },
            axisTicks: { show: false },
            axisBorder: { show: false },
          },
          tooltip: { enabled: false },
          fill: {
            colors: ["#254fb3", "#EF5350", "#FFC107"],
            opacity: 1,
            type: "solid",
          },
          legend: { show: false },
        },
        options3: {
          chart: {
            width: "100%",
            toolbar: {
              tools: {
                download: false,
                selection: false,
                zoom: false,
                zoomin: false,
                zoomout: false,
                pan: false,
                reset: false,
                customIcons: [],
              },
            },
          },
          dataLabels: { enabled: false },
          stroke: { width: 0 },
          yaxis: {
            min: 0,
            max: 100,
            labels: {
              show: false,
            },
          },
          grid: {
            padding: {
              top: 0,
              right: 0,
              bottom: 0,
              left: 0,
            },
            xaxis: { lines: { show: false } },
            yaxis: { lines: { show: false } },
          },
          xaxis: {
            labels: { show: false },
            axisTicks: { show: false },
            axisBorder: { show: false },
          },
          tooltip: { enabled: false },
          fill: {
            colors: ["#254fb3", "#EF5350", "#FFC107"],
            opacity: 1,
            type: "solid",
          },
          legend: { show: false },
        },
        options4: {
          chart: {
            toolbar: {
              tools: {
                download: true,
                selection: false,
                zoom: false,
                zoomin: false,
                zoomout: false,
                pan: false,
                reset: false,
                customIcons: [],
              },
            },
            type: "bar",
            stacked: false,
          },
          dataLabels: { enabled: false },
          tooltip: {
            y: {
              formatter: function (val, index) {
                return val.toFixed(2) + "%";
              },
            },
          },
          stroke: { width: 0 },
          yaxis: {
            min: 0,
            max: 100,
            tickAmount: 5,
            title: { text: undefined },
            labels: {
              formatter: function (val, index) {
                return val.toFixed(0) + "%";
              },
            },
          },
          fill: {
            colors: ["#254fb3", "#EF5350", "#FFC107"],
            opacity: 1,
            type: "solid",
          },
          legend: { show: false },
        },
      };
    },
    computed: {
      bbrbbr() {
        return this.$store.state.bbrbbr.bbrbbr;
      },
      currentBbr() {
        return this.$getCurrentBbr();
      },
      nurbbrbbr() {
        return this.$store.getters["bbrbbr/nurBbrbbr"];
      },
      strichpreis() {
        let strichpreis = this.$store.getters["einstellungen/einstellung"]("strichpreis");
        if (strichpreis) {
          return strichpreis.strichpreis;
        } else {
          return "";
        }
      },
      jahre() {
        let jahre = [];
        let min = Infinity;
        if (this.daten.length > 0) {
          this.daten.forEach((datum) => {
            if (min > datum.substr(0, 4)) {
              min = datum.substr(0, 4);
            }
          });
          // Manuel angepasst durch Fehlzählung in den Jahren 2019 & 2020
          min = 2021;
          for (let i = min; i <= new Date().getFullYear(); i++) {
            jahre.push(parseInt(i));
          }
        } else {
          jahre.push(new Date().getFullYear());
        }
        if (new Date().getMonth() === 0) {
          this.jahrSelect = jahre.indexOf(new Date().getFullYear()) - 1;
          this.monatSelect = 11;
        } else {
          this.jahrSelect = jahre.indexOf(new Date().getFullYear());
          this.monatSelect = new Date().getMonth() - 1;
        }
        return jahre;
      },
      lieferungen() {
        if (this.$store.state.bierlieferungen.bierlieferungen.loaded === false) {
          this.$store.dispatch("bierlieferungen/loadBierlieferungen");
        }
        return this.$store.state.bierlieferungen.bierlieferungen;
      },
      zahlungen() {
        if (this.$store.state.getrankeStand.getrankeStande.length === 0) {
          this.$store.dispatch("getrankeStand/loadGetrankeStande");
        }
        return this.$store.state.getrankeStand.getrankeStande;
      },
      getranke() {
        if (this.$store.state.getranke.getranke.length === 0) {
          this.$store.dispatch("getranke/loadGetranke");
        }
        return this.$store.state.getranke.getranke;
      },
      daten() {
        let daten = [];
        this.zahlungen.forEach((zahlung) => {
          daten.push(zahlung.datum);
        });
        return daten;
      },
      statistiken() {
        if (this.$store.state.statistiken.statistiken.length === 0) {
          this.$store.dispatch("statistiken/loadStatistiken");
        }
        return this.$store.state.statistiken.statistiken;
      },
      statistik() {
        let monat = this.jahre[this.jahrSelect] + "-" + this.monate[this.monatSelect];
        let selectStatistik = this.statistiken.find((statistik) => statistik.monat === monat);
        if (selectStatistik !== undefined) {
          selectStatistik.stricheProBbrSortiert = [];
          selectStatistik.stricheProStatus = {};
          selectStatistik.stricheProStatusSortiert = [];
          selectStatistik.stricheBbrAnzahl = 0;
          for (var item in selectStatistik.stricheProBbr) {
            let bbr = this.$store.getters["bbrbbr/bbr"](item);
            if (bbr) {
              if (selectStatistik.stricheProStatus[bbr.status] === undefined) {
                selectStatistik.stricheProStatus[bbr.status] = parseInt([selectStatistik.stricheProBbr[item]]);
              } else {
                selectStatistik.stricheProStatus[bbr.status] += parseInt(selectStatistik.stricheProBbr[item]);
              }
              if (bbr.status !== "Chargen & Ämter") {
                selectStatistik.stricheProBbrSortiert.push([item, selectStatistik.stricheProBbr[item]]);
              }
              selectStatistik.stricheBbrAnzahl += parseInt(selectStatistik.stricheProBbr[item]);
            }
          }
          for (var item2 in selectStatistik.stricheProStatus) {
            if (item2 !== "Chargen & Ämter") {
              selectStatistik.stricheProStatusSortiert.push([item2, selectStatistik.stricheProStatus[item2]]);
            }
          }
          if (selectStatistik.stricheProBbrSortiert.length > 0) {
            selectStatistik.stricheProBbrSortiert.sort(function (a, b) {
              return b[1] - a[1];
            });
            selectStatistik.stricheProStatusSortiert.sort(function (a, b) {
              return b[1] - a[1];
            });
            selectStatistik.stricheProBbrCount = selectStatistik.stricheProBbrSortiert.length;
            selectStatistik.stricheProBbrSortiert = selectStatistik.stricheProBbrSortiert.slice(0, 5);
            selectStatistik.stricheProStatusSortiert = selectStatistik.stricheProStatusSortiert.slice(0, 5);
            selectStatistik.stricheProTagBest = Object.keys(selectStatistik.stricheProTag).reduce(function (a, b) {
              return selectStatistik.stricheProTag[a] > selectStatistik.stricheProTag[b] ? a : b;
            });
          }
          selectStatistik.stricheProTagBest = [
            selectStatistik.stricheProTagBest,
            selectStatistik.stricheProTag[selectStatistik.stricheProTagBest],
          ];
          this.series = this.jahresStatistik.schankverlust;
          return selectStatistik;
        } else {
          return null;
        }
      },
      zahlungExist() {
        this.errorMessage = [];
        let error = false;
        let start = this.jahre[this.jahrSelect] + "-" + this.monate[this.monatSelect] + "-01";
        let ende;
        if (this.monate[this.monatSelect] === "12") {
          ende = parseInt(this.jahre[this.jahrSelect]) + 1 + "-01-01";
        } else {
          ende = this.jahre[this.jahrSelect] + "-" + this.monate[this.monatSelect + 1] + "-01";
        }
        if (this.zahlungen.find((zahlung) => zahlung.datum === start) === undefined) {
          start = new Date(new Date(start).getTime()).toLocaleString(["de-de"], { month: "short", year: "numeric" });
          this.errorMessage.push(["error", "Für den Monat " + start + " ist keine Getränkezählung vorhanden."]);
          error = true;
        } else {
          start = new Date(new Date(start).getTime()).toLocaleString(["de-de"], { month: "short", year: "numeric" });
          this.errorMessage.push(["success", "Für den Monat " + start + " ist eine Getränkezählung vorhanden."]);
        }
        if (this.zahlungen.find((zahlung) => zahlung.datum === ende) === undefined) {
          ende = new Date(new Date(ende).getTime()).toLocaleString(["de-de"], { month: "short", year: "numeric" });
          this.errorMessage.push(["error", "Für den Monat " + ende + " ist keine Getränkezählung vorhanden."]);
          error = true;
        } else {
          start = new Date(new Date(start).getTime()).toLocaleString(["de-de"], { month: "short", year: "numeric" });
          this.errorMessage.push(["success", "Für den Monat " + ende + " ist eine Getränkezählung vorhanden."]);
        }
        if (error) {
          return false;
        } else {
          return true;
        }
      },
      jahrStatistik() {
        try {
          let jahrStatistik = {
            monat: [],
            gesamtStricheTheorie: { data: [], name: "gesamtStricheTheorie", summe: 0 },
            gesamtStrichePraxis: { data: [], name: "gesamtStrichePraxis", summe: 0 },
            gesamtStriche: { data: [], name: "gesamtStriche", summe: 0 },
            umsatz: {
              striche: 0,
              ekp: 0,
              pauschal: 0,
              summe: 0,
              bierkasse: 0,
              aktivenkasse: 0,
              ahv: 0,
              hbv: 0,
              fuxia: 0,
              couleur: 0,
            },
            einkauf: { bierschneider: 0, metro: 0, oettinger: 0, rewe: 0, vendel: 0, vinos: 0, summe: 0 },
            tageAnDerTheke: 0,
            couleurstriche: 0,
            couleurstrichePreis: 0,
            verbrauchBier: [],
            verbrauchBierSorte: [],
            verbrauchSoftdrinks: [],
            verbrauchWeinSchnaps: [],
            besterTag: { datum: "", anzahl: 0 },
            schankverlust: { data: [], name: "schankverlust", gesamt: 0, preis: 0 },
            oettingerKisten: { data: [], name: "oettingerKisten", summe: 0, preis: 0 },
            volumen: [
              { data: [], name: "Bier", summe: 0 },
              { data: [], name: "Softdrinks", summe: 0 },
              { data: [], name: "Wein & Schnaps", summe: 0 },
            ],
            bestenliste: [],
            vermogen: [],
            stricheProTag: [],
            stricheProTagMax: 0,
          };
          if (this.$store.state.rechnungen.loaded === false) {
            this.$store.dispatch("rechnungen/loadRechnungen");
          }
          this.$store.getters["rechnungen/rechnungenKasse"]("Bierkasse").forEach((item) => {
            if (
              item.rechnung_datum >= this.jahre[this.jahrSelect] + "-00-01" &&
              item.rechnung_datum <= this.jahre[this.jahrSelect] + "-12-31"
            ) {
              item.positionen.forEach((pos) => {
                if (pos.was === "Striche") {
                  jahrStatistik.umsatz.striche += parseFloat(pos.betrag);
                }
                if (pos.was === "EKP") {
                  jahrStatistik.umsatz.ekp += parseFloat(pos.betrag);
                }
                if (pos.was === "Pauschal") {
                  jahrStatistik.umsatz.pauschal += parseFloat(pos.betrag);
                }
              });
              if (item.bbrID === "uOxOwxMlxii8wP36HTQN") {
                jahrStatistik.umsatz.bierkasse += parseFloat(item.summe);
              }
              if (item.bbrID === "G93SCUDovOqQxC57OcLD") {
                jahrStatistik.umsatz.aktivenkasse += parseFloat(item.summe);
              }
              if (item.bbrID === "qYxK7eWD49Z3rSNadrty") {
                jahrStatistik.umsatz.ahv += parseFloat(item.summe);
              }
              if (item.bbrID === "vHLz8vyb6bwfwzQd0hRP") {
                jahrStatistik.umsatz.hbv += parseFloat(item.summe);
              }
              if (item.bbrID === "1VHmwi95sFWuvyhLjR9I") {
                jahrStatistik.umsatz.fuxia += parseFloat(item.summe);
              }
              if (item.bbrID === "n5Iw2noJm7jRUutEoNb5") {
                jahrStatistik.umsatz.couleur += parseFloat(item.summe);
              }
              jahrStatistik.umsatz.summe += parseFloat(item.summe);
            }
          });
          if (this.$store.state.bierlieferungen.bierlieferungen.length === 0) {
            this.$store.dispatch("bierlieferungen/loadBierlieferungen");
          }
          this.$store.state.bierlieferungen.bierlieferungen.forEach((item) => {
            if (
              item.datum >= this.jahre[this.jahrSelect] + "-00-01" &&
              item.datum <= this.jahre[this.jahrSelect] + "-12-31"
            ) {
              if (item.lieferant === "Bier Schneider") {
                jahrStatistik.einkauf.bierschneider += parseFloat(item.gesamt);
              }
              if (item.lieferant === "Metro") {
                jahrStatistik.einkauf.metro += parseFloat(item.gesamt);
              }
              if (item.lieferant === "Oettinger") {
                jahrStatistik.einkauf.oettinger += parseFloat(item.gesamt);
              }
              if (item.lieferant === "Rewe") {
                jahrStatistik.einkauf.rewe += parseFloat(item.gesamt);
              }
              if (item.lieferant === "Getränke Vendel") {
                jahrStatistik.einkauf.vendel += parseFloat(item.gesamt);
              }
              if (item.lieferant === "Vinos") {
                jahrStatistik.einkauf.vinos += parseFloat(item.gesamt);
              }
              jahrStatistik.einkauf.summe += parseFloat(item.gesamt);
            }
          });
          this.statistiken.forEach((monat) => {
            if (
              monat.monat >= this.jahre[this.jahrSelect] + "-00" &&
              monat.monat <= this.jahre[this.jahrSelect] + "-12"
            ) {
              jahrStatistik.monat.push(
                new Date(monat.monat).toLocaleString(["de-de"], { month: "short", year: "2-digit" })
              );
              jahrStatistik.gesamtStricheTheorie.data.push(monat.gesamtStricheTheorie);
              jahrStatistik.gesamtStricheTheorie.summe += parseFloat(monat.gesamtStricheTheorie);
              jahrStatistik.gesamtStrichePraxis.data.push(monat.gesamtStrichePraxis);
              jahrStatistik.gesamtStrichePraxis.summe += parseFloat(monat.gesamtStrichePraxis);
              jahrStatistik.gesamtStriche.data.push(0);
              jahrStatistik.schankverlust.data.push(monat.schankverlust);
              jahrStatistik.schankverlust.preis +=
                (monat.gesamtStricheTheorie - monat.gesamtStrichePraxis) * monat.durchschnittsStrichPreis;
              jahrStatistik.oettingerKisten.data.push(monat.oettingerKisten);
              jahrStatistik.oettingerKisten.summe += parseFloat(monat.oettingerKisten);
              jahrStatistik.oettingerKisten.preis += parseFloat(monat.oettingerKistenPreis);
              jahrStatistik.couleurstriche += parseInt(monat.couleurstricheAnzahl);
              jahrStatistik.couleurstrichePreis += parseFloat(monat.couleurstrichePreis);
              jahrStatistik.volumen[0].data.push(monat.verbrauchBierSumme);
              jahrStatistik.volumen[0].summe += parseFloat(monat.verbrauchBierSumme);
              jahrStatistik.volumen[1].data.push(monat.verbrauchSoftdrinksSumme);
              jahrStatistik.volumen[1].summe += parseFloat(monat.verbrauchSoftdrinksSumme);
              jahrStatistik.volumen[2].data.push(monat.verbrauchWeinSchnapsSumme);
              jahrStatistik.volumen[2].summe += parseFloat(monat.verbrauchWeinSchnapsSumme);
              jahrStatistik.vermogen.push(this.$sumArray(monat.gesamtvermogen));

              jahrStatistik.stricheProTag.push({
                tage: [],
                summe: 0,
              });
              let month = parseInt(monat.monat.split("-")[1]) - 1;
              let date = new Date(this.jahre[this.jahrSelect], month, 1);
              while (date.getMonth() === month) {
                jahrStatistik.stricheProTag[month].tage.push(0);
                date.setDate(date.getDate() + 1);
              }
              for (const [key, value] of Object.entries(monat.stricheProTag)) {
                let date = key.split("-");
                jahrStatistik.stricheProTag[date[1] - 1].tage[date[2] - 1] = value;
                jahrStatistik.stricheProTag[date[1] - 1].summe += parseInt(value);
              }
              if (jahrStatistik.stricheProTag[month].summe > jahrStatistik.stricheProTagMax) {
                jahrStatistik.stricheProTagMax = jahrStatistik.stricheProTag[month].summe;
              }
              for (var item in monat.stricheProBbr) {
                jahrStatistik.gesamtStriche.summe += monat.stricheProBbr[item];
                jahrStatistik.gesamtStriche.data[month] += monat.stricheProBbr[item];
                if (jahrStatistik.bestenliste.find((element) => element.bbr === item)) {
                  jahrStatistik.bestenliste[
                    jahrStatistik.bestenliste.indexOf(jahrStatistik.bestenliste.find((element) => element.bbr === item))
                  ].anzahl += parseInt(monat.stricheProBbr[item]);
                } else {
                  if (monat.stricheProBbr[item] > 0) {
                    if (this.showNurBbrBbr) {
                      if (this.$store.getters["bbrbbr/nurBbrbbr"].find((bbr) => bbr.id === item) !== undefined) {
                        jahrStatistik.bestenliste.push({ bbr: item, anzahl: monat.stricheProBbr[item] });
                      }
                    } else {
                      jahrStatistik.bestenliste.push({ bbr: item, anzahl: monat.stricheProBbr[item] });
                    }
                  }
                }
              }
              for (var item2 in monat.stricheProTag) {
                jahrStatistik.tageAnDerTheke++;
                if (jahrStatistik.besterTag.anzahl < monat.stricheProTag[item2]) {
                  jahrStatistik.besterTag = { datum: item2, anzahl: monat.stricheProTag[item2] };
                }
              }
              for (var item3 in monat.verbrauchBier) {
                if (
                  jahrStatistik.verbrauchBier.find(
                    (element) => element.bezeichnung === monat.verbrauchBier[item3].bezeichnung
                  )
                ) {
                  jahrStatistik.verbrauchBier[
                    jahrStatistik.verbrauchBier.indexOf(
                      jahrStatistik.verbrauchBier.find(
                        (element) => element.bezeichnung === monat.verbrauchBier[item3].bezeichnung
                      )
                    )
                  ].anzahl += parseInt(monat.verbrauchBier[item3].verbraucht);
                  jahrStatistik.verbrauchBier[
                    jahrStatistik.verbrauchBier.indexOf(
                      jahrStatistik.verbrauchBier.find(
                        (element) => element.bezeichnung === monat.verbrauchBier[item3].bezeichnung
                      )
                    )
                  ].ekp += parseInt(monat.verbrauchBier[item3].ekp);
                } else {
                  let getrank = this.getranke.find(
                    (getrank) => getrank.bezeichnung === monat.verbrauchBier[item3].bezeichnung
                  );
                  jahrStatistik.verbrauchBier.push({
                    bezeichnung: monat.verbrauchBier[item3].bezeichnung,
                    anzahl: monat.verbrauchBier[item3].verbraucht,
                    ekp: monat.verbrauchBier[item3].ekp,
                    getrank: getrank,
                  });
                }
              }
              for (var item4 in monat.verbrauchSoftdrinks) {
                if (
                  jahrStatistik.verbrauchSoftdrinks.find(
                    (element) => element.bezeichnung === monat.verbrauchSoftdrinks[item4].bezeichnung
                  )
                ) {
                  jahrStatistik.verbrauchSoftdrinks[
                    jahrStatistik.verbrauchSoftdrinks.indexOf(
                      jahrStatistik.verbrauchSoftdrinks.find(
                        (element) => element.bezeichnung === monat.verbrauchSoftdrinks[item4].bezeichnung
                      )
                    )
                  ].anzahl += parseInt(monat.verbrauchSoftdrinks[item4].verbraucht);
                  jahrStatistik.verbrauchSoftdrinks[
                    jahrStatistik.verbrauchSoftdrinks.indexOf(
                      jahrStatistik.verbrauchSoftdrinks.find(
                        (element) => element.bezeichnung === monat.verbrauchSoftdrinks[item4].bezeichnung
                      )
                    )
                  ].ekp += parseInt(monat.verbrauchSoftdrinks[item4].ekp);
                } else {
                  let getrank2 = this.getranke.find(
                    (getrank) => getrank.bezeichnung === monat.verbrauchSoftdrinks[item4].bezeichnung
                  );
                  if (monat.verbrauchSoftdrinks[item4].verbraucht > 0) {
                    jahrStatistik.verbrauchSoftdrinks.push({
                      bezeichnung: monat.verbrauchSoftdrinks[item4].bezeichnung,
                      anzahl: monat.verbrauchSoftdrinks[item4].verbraucht,
                      ekp: monat.verbrauchSoftdrinks[item4].ekp,
                      getrank: getrank2,
                    });
                  }
                }
              }
              for (var item5 in monat.verbrauchWeinSchnaps) {
                if (
                  jahrStatistik.verbrauchWeinSchnaps.find(
                    (element) => element.bezeichnung === monat.verbrauchWeinSchnaps[item5].bezeichnung
                  )
                ) {
                  jahrStatistik.verbrauchWeinSchnaps[
                    jahrStatistik.verbrauchWeinSchnaps.indexOf(
                      jahrStatistik.verbrauchWeinSchnaps.find(
                        (element) => element.bezeichnung === monat.verbrauchWeinSchnaps[item5].bezeichnung
                      )
                    )
                  ].anzahl += parseInt(monat.verbrauchWeinSchnaps[item5].verbraucht);
                  jahrStatistik.verbrauchWeinSchnaps[
                    jahrStatistik.verbrauchWeinSchnaps.indexOf(
                      jahrStatistik.verbrauchWeinSchnaps.find(
                        (element) => element.bezeichnung === monat.verbrauchWeinSchnaps[item5].bezeichnung
                      )
                    )
                  ].ekp += parseInt(monat.verbrauchWeinSchnaps[item5].ekp);
                } else {
                  let getrank2 = this.getranke.find(
                    (getrank) => getrank.bezeichnung === monat.verbrauchWeinSchnaps[item5].bezeichnung
                  );
                  jahrStatistik.verbrauchWeinSchnaps.push({
                    bezeichnung: monat.verbrauchWeinSchnaps[item5].bezeichnung,
                    anzahl: monat.verbrauchWeinSchnaps[item5].verbraucht,
                    ekp: monat.verbrauchWeinSchnaps[item5].ekp,
                    getrank: getrank2,
                  });
                }
              }
            }
          });
          jahrStatistik.verbrauchBier.forEach((eintrag) => {
            let getrank = this.getranke.find((element) => element.bezeichnung === eintrag.bezeichnung);
            if (getrank !== undefined) {
              eintrag.liter = (getrank.volumen * eintrag.anzahl).toFixed(0);
            }
          });
          jahrStatistik.verbrauchBier.reduce(function (res, value) {
            value.Id = value.bezeichnung.split(" ")[0];
            if (!res[value.Id]) {
              res[value.Id] = { Id: value.Id, liter: 0 };
              jahrStatistik.verbrauchBierSorte.push(res[value.Id]);
            }
            if (value.liter) {
              res[value.Id].liter += parseFloat(value.liter);
            }
            return res;
          }, {});
          jahrStatistik.verbrauchSoftdrinks.forEach((eintrag) => {
            if (eintrag.getrank !== undefined) {
              eintrag.liter = (eintrag.getrank.volumen * eintrag.anzahl).toFixed(0);
            }
            if (eintrag.liter === undefined) {
              eintrag.liter = 0;
            }
          });
          jahrStatistik.verbrauchWeinSchnaps.forEach((eintrag) => {
            let getrank = this.getranke.find((element) => element.bezeichnung === eintrag.bezeichnung);
            if (getrank !== undefined) {
              eintrag.liter = (getrank.volumen * eintrag.anzahl).toFixed(0);
            }
          });
          jahrStatistik.verbrauchBier.sort(function (a, b) {
            return b.liter - a.liter;
          });
          jahrStatistik.verbrauchBierSorte.sort(function (a, b) {
            return b.liter - a.liter;
          });
          jahrStatistik.verbrauchSoftdrinks.sort(function (a, b) {
            return b.liter - a.liter;
          });
          jahrStatistik.verbrauchWeinSchnaps.sort(function (a, b) {
            return b.liter - a.liter;
          });
          jahrStatistik.bestenliste.sort(function (a, b) {
            return b.anzahl - a.anzahl;
          });
          jahrStatistik.volumen[0].summe = jahrStatistik.volumen[0].summe.toFixed(0);
          jahrStatistik.volumen[1].summe = jahrStatistik.volumen[1].summe.toFixed(0);
          jahrStatistik.volumen[2].summe = jahrStatistik.volumen[2].summe.toFixed(0);
          jahrStatistik.volumen.donut = {
            series: [
              parseInt(jahrStatistik.volumen[0].summe),
              parseInt(jahrStatistik.volumen[1].summe),
              parseInt(jahrStatistik.volumen[2].summe),
            ],
          };
          jahrStatistik.volumen.chartOptions = {
            labels: ["Bier", "Softdrinks", "Wein & Schnaps"],
            legend: { show: false },
            colors: ["#254fb3", "#EF5350", "#FFC107"],
            tooltip: {
              y: {
                formatter: function (val) {
                  return val + " Liter";
                },
              },
            },
            plotOptions: {
              pie: {
                donut: {
                  size: "65%",
                  labels: {
                    show: true,
                    value: {
                      fontSize: "1.25rem",
                      fontFamily: "Roboto, Arial",
                      fontWeight: 500,
                    },
                    total: {
                      show: true,
                      showAlways: true,
                      label: "SUMME",
                      fontSize: "0.75rem",
                      fontFamily: "Roboto, Arial",
                      fontWeight: 500,
                    },
                  },
                },
              },
            },
          };
          jahrStatistik.verbrauchBier.donut = { series: [] };
          jahrStatistik.verbrauchBier.chartOptions = {
            labels: [],
            legend: { show: false },
            colors: ["#254fb3", "#EF5350", "#FFC107", "#009688", "#CDDC39", "#FF9800", "#03A9F4"],
            tooltip: {
              y: {
                formatter: function (val) {
                  return val + " Liter";
                },
              },
            },
            plotOptions: {
              radialBar: {
                offsetY: 0,
                startAngle: 0,
                endAngle: 270,
                hollow: {
                  margin: 0,
                  size: "40%",
                  background: "transparent",
                },
              },
              pie: {
                donut: {
                  size: "65%",
                },
              },
            },
          };
          jahrStatistik.verbrauchBierSorte.forEach((sorte) => {
            jahrStatistik.verbrauchBier.donut.series.push(
              ((sorte.liter / jahrStatistik.volumen[0].summe) * 100).toFixed(1)
            );
            jahrStatistik.verbrauchBier.chartOptions.labels.push(sorte.Id);
          });
          jahrStatistik.schankverlust.gesamt = (
            100 -
            (jahrStatistik.gesamtStrichePraxis.summe / jahrStatistik.gesamtStricheTheorie.summe) * 100
          ).toFixed(1);
          return jahrStatistik;
        } catch (error) {
          console.log("Fehler beim Berechnen der Jahresstatistik");
          console.log(error);
        }
      },
      jahresStatistik() {
        let jahresStatistik = {
          monat: [],
          gesamtStriche: [
            { data: [], name: "Striche Theorie" },
            { data: [], name: "Striche Praxis" },
          ],
          gesamtStricheTheorie: [{ data: [], name: "gesamtStricheTheorie" }],
          gesamtStrichePraxis: [{ data: [], name: "gesamtStrichePraxis" }],
          schankverlust: [{ data: [], name: "schankverlust" }],
          oettingerKisten: [{ data: [], name: "oettingerKisten" }],
          volumen: [
            { data: [], name: "Bier" },
            { data: [], name: "Softdrinks" },
            { data: [], name: "Wein & Schnaps" },
          ],
          verbrauchBier: [{ data: [], name: "verbrauchBier" }],
          verbrauchSoftdrinks: [{ data: [], name: "verbrauchSoftdrinks" }],
          verbrauchWeinSchnaps: [{ data: [], name: "verbrauchWeinSchnaps" }],
          verbrauchBierSumme: [{ data: [], name: "verbrauchBierSumme" }],
          verbrauchSoftdrinksSumme: [{ data: [], name: "verbrauchSoftdrinksSumme" }],
          verbrauchWeinSchnapsSumme: [{ data: [], name: "verbrauchWeinSchnapsSumme" }],
        };
        this.statistiken.forEach((monat) => {
          if (monat.monat > "2021-00") {
            jahresStatistik.monat.push(
              new Date(monat.monat).toLocaleString(["de-de"], { month: "short", year: "2-digit" })
            );
            jahresStatistik.gesamtStriche[0].data.push(monat.gesamtStricheTheorie);
            jahresStatistik.gesamtStriche[1].data.push(monat.gesamtStrichePraxis);
            jahresStatistik.gesamtStricheTheorie[0].data.push(monat.gesamtStricheTheorie);
            jahresStatistik.gesamtStrichePraxis[0].data.push(monat.gesamtStrichePraxis);
            jahresStatistik.schankverlust[0].data.push(monat.schankverlust);
            jahresStatistik.oettingerKisten[0].data.push(monat.oettingerKisten);
            // jahresStatistik.volumen[0].data.push(monat.volumen)
            jahresStatistik.volumen[0].data.push(monat.verbrauchBierSumme);
            jahresStatistik.volumen[1].data.push(monat.verbrauchSoftdrinksSumme);
            jahresStatistik.volumen[2].data.push(monat.verbrauchWeinSchnapsSumme);
            jahresStatistik.verbrauchBier[0].data.push(monat.verbrauchBierSumme);
            jahresStatistik.verbrauchSoftdrinks[0].data.push(monat.verbrauchSoftdrinksSumme);
            jahresStatistik.verbrauchWeinSchnaps[0].data.push(monat.verbrauchWeinSchnapsSumme);
            jahresStatistik.verbrauchBierSumme[0].data.push(monat.verbrauchBierSumme);
            jahresStatistik.verbrauchSoftdrinksSumme[0].data.push(monat.verbrauchSoftdrinksSumme);
            jahresStatistik.verbrauchWeinSchnapsSumme[0].data.push(monat.verbrauchWeinSchnapsSumme);
          }
        });
        this.options.xaxis.categories = jahresStatistik.monat;
        console.log(jahresStatistik);
        return jahresStatistik;
      },
      preiskalkulation() {
        let ergebnis = {};
        let stricheKostenGesamt = 0;
        let ekpKostenGesamt = 0;
        let ekpEinnahmenGesamt = 0;
        let strichpreis = 1.2;
        console.log(this.jahrStatistik);
        this.jahrStatistik.verbrauchBier.forEach((item) => {
          if (item.getrank) {
            stricheKostenGesamt +=
              ((item.anzahl - item.ekp) / parseInt(item.getrank.verkaufseinheit)) * parseFloat(item.getrank.preis);
            ekpKostenGesamt += (item.ekp / parseInt(item.getrank.verkaufseinheit)) * parseFloat(item.getrank.preis);
            ekpEinnahmenGesamt +=
              (item.ekp / parseInt(item.getrank.verkaufseinheit)) * parseFloat(item.getrank.verkauf1);
          }
        });
        this.jahrStatistik.verbrauchSoftdrinks.forEach((item) => {
          if (item.getrank) {
            stricheKostenGesamt +=
              ((item.anzahl - item.ekp) / parseInt(item.getrank.verkaufseinheit)) * parseFloat(item.getrank.preis);
            ekpKostenGesamt += (item.ekp / parseInt(item.getrank.verkaufseinheit)) * parseFloat(item.getrank.preis);
            ekpEinnahmenGesamt +=
              (item.ekp / parseInt(item.getrank.verkaufseinheit)) * parseFloat(item.getrank.verkauf1);
          }
        });
        this.jahrStatistik.verbrauchWeinSchnaps.forEach((item) => {
          if (item.getrank) {
            ekpKostenGesamt += (item.anzahl / parseInt(item.getrank.verkaufseinheit)) * parseFloat(item.getrank.preis);
            ekpEinnahmenGesamt +=
              (item.ekp / parseInt(item.getrank.verkaufseinheit)) * parseFloat(item.getrank.verkauf1);
          }
        });
        console.log(ekpEinnahmenGesamt);
        ergebnis.kostenStriche =
          stricheKostenGesamt /
          (this.jahrStatistik.gesamtStriche.summe +
            this.jahrStatistik.gesamtStricheTheorie.summe -
            this.jahrStatistik.gesamtStrichePraxis.summe);
        ergebnis.kostenEKP =
          ekpKostenGesamt / (this.jahrStatistik.gesamtStrichePraxis.summe - this.jahrStatistik.gesamtStriche.summe);
        ergebnis.kostenSchankverlust = ergebnis.kostenStriche;
        ergebnis.einnahmenStriche = strichpreis;
        ergebnis.einnahmenEKP =
          ekpEinnahmenGesamt / (this.jahrStatistik.gesamtStrichePraxis.summe - this.jahrStatistik.gesamtStriche.summe);
        ergebnis.einnahmenSchankverlust = 0;
        ergebnis.gewinnStriche = ergebnis.einnahmenStriche - ergebnis.kostenStriche;
        ergebnis.gewinnEKP = ergebnis.einnahmenEKP - ergebnis.kostenEKP;
        ergebnis.gewinnSchankverlust = ergebnis.einnahmenSchankverlust - ergebnis.kostenSchankverlust;
        return ergebnis;
      },
    },
    methods: {
      saveGesamtvermogen() {
        this.$store.dispatch("statistiken/updateStatistikenData", this.statistik);
      },
      showVermogen() {
        if (!this.statistik.gesamtvermogen) {
          this.statistik.gesamtvermogen = {};
        }
        this.showArray = "vermogen";
      },
      show(array) {
        let max = 0;
        array.forEach((data) => {
          data.data.forEach((item) => {
            if (parseInt(item) > max) {
              max = parseInt(item);
            }
          });
        });
        this.options.yaxis.max =
          Math.ceil(max / Math.pow(10, max.toString().length - 1)) * Math.pow(10, max.toString().length - 1);
        this.series = array;
      },
      addMonat(neuerMonat) {
        this.filterVon = this.jahre[this.jahrSelect] + "-" + this.monate[this.monatSelect] + "-01";
        if (this.monate[this.monatSelect] === "12") {
          this.filterBis = parseInt(this.jahre[this.jahrSelect]) + 1 + "-01-01";
        } else {
          this.filterBis = this.jahre[this.jahrSelect] + "-" + this.monate[this.monatSelect + 1] + "-01";
        }
        let von = new Date(this.filterVon);
        if (von.getTimezoneOffset() === -60) {
          von = new Date(von.setHours(von.getHours() - 2));
        }
        let bis = new Date(this.filterBis);
        console.log(bis.getTimezoneOffset());
        if (bis.getTimezoneOffset() === -60) {
          bis = new Date(bis.setHours(bis.getHours() - 2));
        }
        if (bis.getTimezoneOffset() === -120) {
          bis = new Date(bis.setHours(bis.getHours() - 4));
        }
        let datum = {
          von: von,
          bis: bis,
        };
        console.log(datum.von);
        console.log(datum.bis);
        let gesamtStricheTheorie = 0;
        let gesamtStrichePraxis = 0;
        let verbrauchBierSumme = 0;
        let verbrauchSoftdrinksSumme = 0;
        let verbrauchWeinSchnapsSumme = 0;
        let oettingerKisten = 0;
        let oettingerKistenPreis = 0;
        let volumen = 0;
        let couleurstricheAnzahl = 0;
        let couleurstrichePreis = 0;
        let durchschnittsStrichPreis = 0;
        let stricheAnzahl = 0;
        let strichePreis = 0;

        this.$store.dispatch("striche/loadAlleStriche", datum);
        let striche = [];
        let result = {};
        let resultDate = {};
        let array = {};
        let arrayDate = {};
        this.$store.state.striche.alleStriche.forEach((strich) => {
          let art;
          if (!result[strich["bbrID"]]) {
            result[strich["bbrID"]] = [];
            array[strich["bbrID"]] = 0;
          }
          let tzoffset = new Date().getTimezoneOffset() * 60000;
          let date = new Date(strich.date.seconds * 1000 - tzoffset).toISOString().substr(0, 10);
          if (!resultDate[date]) {
            resultDate[date] = [];
            arrayDate[date] = 0;
          }
          result[strich["bbrID"]].push(strich);
          resultDate[date].push(strich);
          if (strich.art === "strich") {
            stricheAnzahl += parseInt(strich.anzahl);
            strichePreis += parseInt(strich.anzahl) * parseFloat(strich.preis);
            array[strich["bbrID"]] += parseInt(strich.anzahl);
            arrayDate[date] += parseInt(strich.anzahl);
            if (strich.bbrID === "n5Iw2noJm7jRUutEoNb5") {
              couleurstricheAnzahl += parseInt(strich.anzahl);
              couleurstrichePreis += parseFloat(strich.preis * strich.anzahl);
            }
            if (strich.bbrID === "G93SCUDovOqQxC57OcLD") {
              couleurstricheAnzahl += parseInt(strich.anzahl);
              couleurstrichePreis += parseFloat(strich.preis * strich.anzahl);
            }
            if (strich.bbrID === "uOxOwxMlxii8wP36HTQN") {
              couleurstricheAnzahl += parseInt(strich.anzahl);
              couleurstrichePreis += parseFloat(strich.preis * strich.anzahl);
            }
          }
          if (strich.ekp) {
            if (strich.ekp.id) {
              art = strich.ekp.id;
            } else {
              art = strich.ekp[0].id;
            }
          } else {
            if (strich.grund) {
              art = strich.grund;
            } else {
              art = "";
            }
          }
          striche.push({
            id: strich.id,
            bbr: strich.bbrID,
            art: art,
            anzahl: strich.anzahl,
            datum: date,
            preis: strich.preis,
          });
        });
        durchschnittsStrichPreis = parseFloat(strichePreis / stricheAnzahl).toFixed(2);

        let verbrauch = [];
        verbrauch["Bier"] = [];
        verbrauch["Softdrinks"] = [];
        verbrauch["Wein & Schnaps"] = [];

        let anfang;
        let ende;
        // Sucht die Zahlung vom Startdatum raus
        if (this.zahlungen.find((zahlung) => zahlung.datum === this.filterVon) === undefined) {
          let statistik = {
            error:
              "Für diesen Monat ist keine Statistik verfügbar, da zum Monatsanfang keine Zählung durchgeführt wurde.",
          };
          console.log(statistik);
          this.$store.dispatch("statistiken/createStatistiken", statistik);
          return;
        } else {
          anfang = this.zahlungen.find((zahlung) => zahlung.datum === this.filterVon).positionen;
        }
        // Sucht die Zahlung vom Enddatum raus
        if (this.zahlungen.find((zahlung) => zahlung.datum === this.filterBis) === undefined) {
          let statistik = {
            error:
              "Für diesen Monat ist keine Statistik verfügbar, da zum Monatsende noch keine Zählung durchgeführt wurde.",
          };
          console.log(statistik);
          this.$store.dispatch("statistiken/createStatistiken", statistik);
          return;
        } else {
          ende = this.zahlungen.find((zahlung) => zahlung.datum === this.filterBis).positionen;
        }
        // Geht alle Getränke durch
        let einkaufMwStGesamt = 0;
        this.lieferungen.forEach((lieferung) => {
          if (new Date(lieferung.datum).toISOString().substr(0, 10) >= this.filterVon) {
            if (new Date(lieferung.datum).toISOString().substr(0, 10) <= this.filterBis) {
              console.log(lieferung);
              einkaufMwStGesamt += parseFloat(lieferung.mwst);
            }
          }
        });
        this.getranke.forEach((item) => {
          let eingekauft = 0;
          // Zählt alle Lieferungen
          this.lieferungen.forEach((lieferung) => {
            if (new Date(lieferung.datum).toISOString().substr(0, 10) >= this.filterVon) {
              if (new Date(lieferung.datum).toISOString().substr(0, 10) <= this.filterBis) {
                lieferung.positionen.forEach((position) => {
                  if (position.id === item.id) {
                    eingekauft = eingekauft + parseFloat(position.anzahl) * item.verkaufseinheit;
                  }
                });
              }
            }
          });
          // Anfangsstand
          let anfangsposition = 0;
          anfang.forEach((position) => {
            if (position.id === item.id) {
              anfangsposition = anfangsposition + parseInt(position.anzahl);
            }
          });
          // Endstand
          let endposition = 0;
          ende.forEach((position) => {
            if (position.id === item.id) {
              endposition = endposition + parseInt(position.anzahl);
            }
          });
          // EKP-Getrunken
          let ekp = 0;
          striche.forEach((strich) => {
            if (strich.art === item.id) {
              let date = new Date(strich.datum).toISOString().substr(0, 10);
              if (date >= this.filterVon && date <= this.filterBis) {
                ekp++;
              }
            }
          });
          // Verbraucht (EKP-Kein Einfluss, da zwar nicht gestrichelt aber verbraucht)
          let verbraucht = anfangsposition + eingekauft - endposition;
          if (item.kategorie === "Bier") {
            verbrauchBierSumme = parseFloat(verbrauchBierSumme) + parseFloat(verbraucht) * parseFloat(item.volumen);
            verbrauchBierSumme = verbrauchBierSumme.toFixed(1);
            if (item.bezeichnung.includes("Oettinger Kiste")) {
              oettingerKisten += verbraucht;
              oettingerKistenPreis += item.preis * verbraucht;
            }
          }
          if (item.kategorie === "Softdrinks") {
            verbrauchSoftdrinksSumme =
              parseFloat(verbrauchSoftdrinksSumme) + parseFloat(verbraucht) * parseFloat(item.volumen);
            verbrauchSoftdrinksSumme = verbrauchSoftdrinksSumme.toFixed(1);
            if (item.bezeichnung.includes("Oettinger Kiste")) {
              oettingerKisten += verbraucht;
              oettingerKistenPreis += item.preis * verbraucht;
            }
          }
          if (item.kategorie === "Wein & Schnaps") {
            verbrauchWeinSchnapsSumme =
              parseFloat(verbrauchWeinSchnapsSumme) + parseFloat(verbraucht) * parseFloat(item.volumen);
            verbrauchWeinSchnapsSumme = verbrauchWeinSchnapsSumme.toFixed(1);
          }
          volumen = (
            parseFloat(verbrauchBierSumme) +
            parseFloat(verbrauchSoftdrinksSumme) +
            parseFloat(verbrauchWeinSchnapsSumme)
          ).toFixed(1);
          // Striche Theorie
          // Diese Zeile muss getauscht werden, wenn ekp Striche in den Schankverlust eingehen sollen oder nicht
          let stricheTheorie;
          stricheTheorie = verbraucht * item.striche;
          gesamtStricheTheorie = parseFloat(gesamtStricheTheorie) + parseFloat(stricheTheorie);
          // Push
          if (eingekauft >= 0 && verbraucht !== 0) {
            verbrauch[item.kategorie].push({
              bezeichnung: item.bezeichnung,
              kategorie: item.kategorie,
              eingekauft: eingekauft,
              anfang: anfangsposition,
              ende: endposition,
              ekp: ekp,
              verbraucht: verbraucht,
              stricheTheorie,
            });
          }
        });
        // Striche Praxis
        striche.forEach((strich) => {
          let date = new Date(strich.datum).toISOString().substr(0, 10);
          if (date >= this.filterVon && date < this.filterBis) {
            if (strich.art === "" || strich.art === "strich" || strich.art === "Strich") {
              gesamtStrichePraxis = gesamtStrichePraxis + parseInt(strich.anzahl);
              // Die drei Zeilen darunter müssen kommentiert werden, wenn ekp nicht in schankverlust gerechnet werden soll
            }
            if (strich.art !== "") {
              if (this.$store.state.getranke.getranke.length === 0) {
                this.$store.dispatch("getranke/loadGetranke");
              }
              let getrank = this.$store.getters["getranke/getrank"](strich.art);
              if (getrank) {
                gesamtStrichePraxis = gesamtStrichePraxis + parseInt(strich.anzahl * getrank.striche);
              }
            }
          }
        });
        // Schankverlust parseFloat(value).toFixed(2)
        let schankverlust = parseFloat(100 - (gesamtStrichePraxis / gesamtStricheTheorie) * 100).toFixed(2);
        // Steuerlast zusammenrechnen
        let steuerlast = einkaufMwStGesamt;
        let statistik = {
          id: this.jahre[this.jahrSelect] + "-" + this.monate[this.monatSelect],
          aktualisiert: new Date(),
          monat: this.jahre[this.jahrSelect] + "-" + this.monate[this.monatSelect],
          gesamtStricheTheorie,
          gesamtStrichePraxis,
          schankverlust,
          oettingerKisten,
          oettingerKistenPreis,
          volumen,
          steuerlast,
          verbrauchBier: verbrauch["Bier"],
          verbrauchSoftdrinks: verbrauch["Softdrinks"],
          verbrauchWeinSchnaps: verbrauch["Wein & Schnaps"],
          verbrauchBierSumme,
          verbrauchSoftdrinksSumme,
          verbrauchWeinSchnapsSumme,
          durchschnittsStrichPreis,
          couleurstricheAnzahl,
          couleurstrichePreis: couleurstrichePreis.toFixed(2),
          stricheProBbr: array,
          stricheProTag: arrayDate,
          // umsatz: '',
        };
        console.log(statistik);
        if (neuerMonat) {
          this.$store.dispatch("statistiken/createStatistiken", statistik);
        } else {
          statistik.id = this.statistik.id;
          this.$store.dispatch("statistiken/updateStatistikenData", statistik);
        }
      },
    },
  };
</script>

<style scoped></style>



// WEBPACK FOOTER //
// bierwartSchankverlust.vue?5214ebbc